import React from "react";
import {DragHandle, Helper, SortableContainer, SortableItem} from "./Helper";

import DailyReport from './DailyReport';
import {Link} from 'react-router-dom';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Calculator from "./Component/Calculator";
// import DatePicker from "react-datepicker";

// import DayPicker from "react-day-picker";
import DayPickerInput from 'react-day-picker/DayPickerInput';
import "react-day-picker/lib/style.css";
// import {
// 	formatDate,
// 	parseDate,
// } from 'react-day-picker/moment';
// import 'moment/locale/th';

import "react-datepicker/dist/react-datepicker.css";
import cloneDeep from 'lodash/cloneDeep';
import icon_img from "./checked.png";
import table_4_img from "./table_4_seat.png";
import table_2_img from "./table_2_seat.png";


window.$focus_input = false;
window.isShowCalculator = false;
const allpage_fontSize = '1.5rem';
const button_padding = '1.5rem';
const button_fontSize = '1.5rem';

function callCalculator(ref) {
	window.$(ref).off('focus').on('focus', () => {
		// window.$(ref).select();
		window.$focus_input = window.$(ref);
		window.$focus_input.attr("autocomplete", "off");
		window.$('#calculator_Root').show();
		window.$('#POS_viewRoot').removeClass('col-xs-16');
		window.$('#POS_viewRoot').addClass('col-xs-12');
		setTimeout(() => {
			window.isShowCalculator = true;
		}, 800);
	});
	return null;
}

function closeCalculator() {
	window.isShowCalculator = false;
	window.$('#calculator_Root').hide();
	window.$('#POS_viewRoot').removeClass('col-xs-12');
	window.$('#POS_viewRoot').addClass('col-xs-16');
	window.$focus_input = false;
}

const backup = console.error;

console.error = function filterWarnings(msg) {
	const supressedWarnings = ['Warning: Legacy context API has been detected within a strict-mode tree.',
		'Warning: %s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://fb.me/react-strict-mode-find-node%s'];

	if (!supressedWarnings.some(entry => msg.includes(entry))) {
		backup.apply(console, arguments);
	}
};


export default class POS extends React.Component {
	constructor() {
		super();
		this.state = {
			canvas_mode: false,
			is_show_table: false,
			change_amount: 0,
			show_working_time: false,
			products: [],
			user: window.user || {},
			limit: 18,
			page: 1,
			search_query: '',
			search_query_barcode: '',
			payments: [],
			pos: localStorage.getItem("pos") && localStorage.getItem("pos") !== '' ? JSON.parse(localStorage.getItem("pos")) : false,
			currentDateReadable: window.moment().format('DD MMM YYYY - hh:mm:ss')
		};
		this.Products = React.createRef();
		this.Payments = React.createRef();
	}


	onScanBarCode(data) {
		data.referrer = data.referrer.replace(/\s/g, '');
		let _quantity = 1;
		let _payment = this.Payments.current.getPayments();
		let payments = this.Payments ? [...this.Payments.current.getPayments()] : [];
		let active_payment = this.Payments && this.Payments.current.getActivePayment() ? this.Payments.current.getActivePayment().index : false;
		if (active_payment !== false) {
			let item_match = false;
			let barcode_index = false;
			// console.log(_payment[active_payment].item);
			if (_payment[active_payment].item.length > 0) {
				_payment[active_payment].item.map((item, item_index) => {
					item.product.product_barcode.map((product_barcode, product_barcode_i) => {
						// console.log(product_barcode);
						if (product_barcode.barcode === data.referrer
							&& parseFloat(item.ratio) === parseFloat(product_barcode.ratio)
						) {
							item_match = item_index; //หาสินค้าที่มีใน item
							barcode_index = product_barcode_i;
						}
						return true;
					});
					return true;
				});
			}
			if (item_match !== false) {
				if (barcode_index !== false) {
					_quantity = parseFloat(payments[active_payment].item[item_match].product.product_barcode[barcode_index]._qty);
				}
				let __quantity = payments[active_payment].item[item_match]._quantity + _quantity;
				payments[active_payment].item[item_match]._quantity = __quantity; //ถ้ามีสินค้าใน item
				payments[active_payment].item[item_match].quantity = __quantity * payments[active_payment].item[item_match].ratio; //ถ้ามีสินค้าใน item

				payments[active_payment].payment.map((_payment, _payment_index) => {
					if (_payment.payment_by === 'cash') {
						payments[active_payment].payment[_payment_index].price = 0;
						payments[active_payment].payment[_payment_index].payment_by_cash_pos.receive_amount = 0;
						payments[active_payment].payment[_payment_index].payment_by_cash_pos.change_amount = 0;
						delete payments[active_payment].payment[_payment_index].payment_by_cash_pos.banknote_1000;
						delete payments[active_payment].payment[_payment_index].payment_by_cash_pos.banknote_500;
						delete payments[active_payment].payment[_payment_index].payment_by_cash_pos.banknote_100;
						delete payments[active_payment].payment[_payment_index].payment_by_cash_pos.banknote_50;
						delete payments[active_payment].payment[_payment_index].payment_by_cash_pos.banknote_20;
						delete payments[active_payment].payment[_payment_index].payment_by_cash_pos.coin_10;
						delete payments[active_payment].payment[_payment_index].payment_by_cash_pos.coin_5;
						delete payments[active_payment].payment[_payment_index].payment_by_cash_pos.coin_1;
					}
					return true;
				});
				// this.setState({
				//     payments: payments
				// });
				this.Payments.current.setPayments(payments);
				return true;
			}
		}
		let _data = {
			// search_query_barcode: data.referrer,

			search_query_barcode_or_serial_number: data.referrer,
			stock_id: this.state.pos.pos_default_payment.stock_id,
			// product_serial_number: true,
			page: 1,
			limit: 1,

			is_deleted: 0,
			is_pos: 1,
			for_relationship_id: this.Payments.current.getRelationShip() ? this.Payments.current.getRelationShip().id : '',
		}
		window.Global.ajax({
			url: process.env.REACT_APP_DOMAIN + '/api/product',
			method: 'GET',
			data: _data,
			done: (responseJson) => {
				if (!responseJson.product
					|| responseJson.product.length !== 1
				) {
					return false;
				}
				this.addItem(responseJson.product[0], responseJson.search_query_barcode_or_serial_number);
			}
		})
	}

	addItem(product, search_query_barcode_or_serial_number) {
		let price = product.default_item_sell.price;
		let _quantity = 1;
		let ratio = product.default_item_sell.ratio;
		let quantity = product.default_item_sell.ratio;
		let discount = product.default_item_sell.discount;
		let discount_type = product.default_item_sell.discount_type;
		product.product_barcode.map((product_barcode) => {
			if (product_barcode.barcode === search_query_barcode_or_serial_number) {
				product.sell_price.map((sell_price) => {
					if (parseFloat(sell_price.ratio) === parseFloat(product_barcode.ratio)) {
						price = sell_price.default_item_sell.price;
						discount = sell_price.default_item_sell.discount;
						discount_type = sell_price.default_item_sell.discount_type;
					}
					return true;
				});
				_quantity = parseFloat(product_barcode._qty);
				ratio = parseFloat(product_barcode.ratio);
				quantity = parseFloat(product_barcode.qty);
			}
			return true;
		});

		let product_serial_number = [];
		let _product_serial_number = [];

		if (product.product_serial_number) {
			product.product_serial_number.map((data) => {
				data.product_serial_number.map((__product_serial_number) => {
					if (__product_serial_number.serial_number === search_query_barcode_or_serial_number) {
						product_serial_number.push(__product_serial_number.id)
						_product_serial_number.push(__product_serial_number)
					}
					return true;
				})
				return true;
			});
		}

		let item = {
			id: '',
			product_id: product.id,
			title: '',
			description: '',
			quantity: quantity,
			_quantity: _quantity,
			ratio: ratio,
			price: price,
			discount: discount,
			discount_type: discount_type,
			tax: this.state.pos.pos_default_payment.item.tax,
			tax_type: this.state.pos.pos_default_payment.item.tax_type,
			product: product,
			product_serial_number: product_serial_number,
			_product_serial_number: _product_serial_number,
		};

		let _payment = this.Payments.current.getPayments();
		// console.log(_payment);
		let payments = this.Payments ? [...this.Payments.current.getPayments()] : [];
		let active_payment = this.Payments && this.Payments.current.getActivePayment() ? this.Payments.current.getActivePayment().index : false;
		_payment.map((payment, payment_index) => {
			if (payment.active) {
				active_payment = payment_index; //ดึง index ของ payment ที่ active อยู่
			}
			return true;
		});

		if (active_payment !== false) {
			let item_match = false;
			if (_payment[active_payment].item.length > 0) {
				_payment[active_payment].item.map((item, item_index) => {
					if (
						parseFloat(item.product_id) === parseFloat(product.id)
						&& parseFloat(item.ratio) === parseFloat(ratio)
						&& parseFloat(item.discount) === parseFloat(discount)
						&& item.discount_type === discount_type
						&& parseFloat(item.price) === parseFloat(price)
					) {
						item_match = item_index; //หาสินค้าที่มีใน item
					}
					return true;
				});
			}
			if (item_match === false) {
				payments[active_payment].item.push(item); //ถ้าไม่มีสินค้าใน item
			} else {
				payments[active_payment].item[item_match]._quantity = payments[active_payment].item[item_match]._quantity + _quantity; //ถ้ามีสินค้าใน item
				payments[active_payment].item[item_match].quantity = payments[active_payment].item[item_match]._quantity * payments[active_payment].item[item_match].ratio; //ถ้ามีสินค้าใน item
			}
		}
		if (active_payment === false) {
			Helper.messageTopPOS({
				type: 'negative',
				message: "โปรดเลือกบิล",
			});
			return;
		}

		this.Payments.current.setPayments(payments);
	}

	componentDidMount() {
		// console.log = console.warn = console.error = () => {};
		// console.error('test');
		window.$('.slide-menu-root').css({display: 'none'});
		window.$('.Wrapper_root').css({padding: 0});
		this.fetchPOS();
		window.localStorage.setItem('payment', '');
		document.addEventListener('contextmenu', event => event.preventDefault());

		this.barcodeHandle();

		window.$('body').off('click.detectClickOutsideCalculator').on("click.detectClickOutsideCalculator", (e) => {
			if (window.isShowCalculator
				&& window.$(e.target).closest('#calculator_Root').length === 0
				&& window.$(e.target).closest('input[type="text"]').length === 0
			) {
				closeCalculator();
			}
		});
		window.history.pushState(null, document.title, window.location.href);
		window.addEventListener('popstate', function (event) {
			window.history.pushState(null, document.title, window.location.href);
		});
	}

	barcodeHandle() {
		var scan_barcode = [];
		var time_last_scan_barcode = new Date();
		var timer_scan_barcode2;
		window.$(document).off('keyup.barcodeHandle').on('keyup.barcodeHandle', (e) => {
			if (e.target
				&& window.$(e.target).is('input')
			) {
				return;
			}

			// console.log(e.key);
			clearTimeout(timer_scan_barcode2);
			timer_scan_barcode2 = setTimeout(function () {
				scan_barcode = [];
			}, 300);

			if (e.key !== 'Enter') {
				scan_barcode.push(e.key);
				time_last_scan_barcode = new Date();
			}
			var diff = ((new Date() - time_last_scan_barcode) / 1000);
			// console.log(diff);
			if (e.key !== 'Enter') {
				return;
			}

			var barcode = scan_barcode.join('');
			scan_barcode = [];
			// console.log(barcode, diff);
			// return;
			if (diff > 1) {
				return false;
			}

			console.log(barcode);

			this.onScanBarCode({
				referrer: barcode,
			});
		});
	}

	fetchPOS() {
		if (!this.state.pos) {
			this.callPOSSelector();
			return false;
		}
		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/pos',
			data: {
				pos_id: this.state.pos.id,
				from_device: 'mobile'
			},
			done: (response) => {
				let pos = response.pos[0];
				let show_working_time = false;
				if (
					(pos && pos.last_pos_shift === false)
					|| (pos && pos.last_pos_shift.type === 'close_shift')
				) {
					show_working_time = true;
				}
				let payments = [];
				if (window.localStorage.getItem("payments_pos_" + pos.id) && window.localStorage.getItem("payments_pos_" + pos.id) !== '') {
					payments = JSON.parse(window.localStorage.getItem("payments_pos_" + pos.id));

				} else {
					payments = this.addPayment([]);
				}
				if (payments.length > 0) {
					payments.map((payment, payment_i) => {
						payments[payment_i].pos_shift_id = pos.last_pos_shift.id
						return true;
					})
				}
				this.setState({
						show_working_time: show_working_time,
						pos: pos,
						last_pos_shift: pos && pos.last_pos_shift ? pos.last_pos_shift : false,
						payments: payments
					}, () => {
						window.localStorage.setItem("pos", JSON.stringify(pos));
						window.localStorage.setItem("payments_pos_" + this.state.pos.id, JSON.stringify(this.state.payments));
						this.Products.current.fetchProduct();
						this.Products.current.fetchFilter();
					}
				)
			}
		})
	}

	addPayment(_payments, payment) {
		if (_payments.length > 0) {
			_payments.map((payment, payment_index) => {
				_payments[payment_index].active = false;
				return false;
			});

		}
		// ค่า Default
		_payments.push({
			title: this.state.payments.length + 1,
			is_tax_invoice: this.state.pos.pos_default_payment.is_tax_invoice,
			type: this.state.pos.pos_default_payment.type,
			method: this.state.pos.pos_default_payment.method,
			tax: this.state.pos.pos_default_payment.tax,
			tax_type: this.state.pos.pos_default_payment.tax_type,
			discount: this.state.pos.pos_default_payment.discount,
			discount_type: this.state.pos.pos_default_payment.discount_type,
			relationship_id: this.state.pos.pos_default_payment.relationship_id,
			relationship: this.state.pos.pos_default_payment.relationship,
			relationship_branch_id: this.state.pos.pos_default_payment.relationship_branch_id,
			relationship_branch: this.state.pos.pos_default_payment.relationship_branch,
			stock_id: this.state.pos.pos_default_payment.stock_id,
			stock: this.state.pos.pos_default_payment.stock,
			is_code_generate_auto: this.state.pos.pos_default_payment.is_code_generate_auto,
			pos_id: this.state.pos.pos_default_payment.pos_id,
			active: true,
			remark: this.state.pos.pos_default_payment.remark,
			tag: this.state.pos.pos_default_payment.tag,
			total_price_withholding_tax: this.state.pos.pos_default_payment.total_price_withholding_tax,
			is_express: this.state.pos.pos_default_payment.is_express,
			pos_shift_id: this.state.pos.last_pos_shift.id,
			item: [],
			payment: [],
			serial_number: [],
			payment_uid: payment && payment.uid ? payment.uid : 'manual-' + (_payments.length + 1)
		});
		return _payments;
	}

	callPOSSelector() {
		window.Global.reactToDom(
			window.$('body'),
			<POSTSelector
				onSuccess={(pos) => {
					this.setState({
						pos: pos,
					}, () => {
						window.localStorage.setItem("pos", JSON.stringify(pos));
						this.fetchPOS();
					})
				}}
				onCloseModal={() => {
					this.fetchPOS();
				}}
			/>
		)
	}

	selectProduct(product, options) {
		// console.log(product);
		let item = {
			id: '',
			product_id: product.id,
			title: '',
			description: '',
			quantity: product.default_item_sell.quantity,
			_quantity: product.default_item_sell.quantity / product.default_item_sell.ratio,
			ratio: product.default_item_sell.ratio,
			price: product.default_item_sell.price,
			discount: product.default_item_sell.discount,
			discount_type: product.default_item_sell.discount_type,
			tax: this.state.pos.pos_default_payment.item.tax,
			tax_type: this.state.pos.pos_default_payment.item.tax_type,
			product: product,
			product_serial_number: [],
			_product_serial_number: [],
		}
		let _payments = [...this.Payments.current.getPayments()];
		let payments = [..._payments];
		let active_payment = false;
		_payments.map((payment, payment_index) => {
			if (payment.active) {
				active_payment = payment_index; //ดึง index ของ payment ที่ active อยู่
			}
			return null;
		});
		let item_match = false;
		if (active_payment !== false) {
			if (_payments[active_payment].item.length > 0) {
				_payments[active_payment].item.map((item, item_index) => {
					if (
						parseFloat(item.product_id) === parseFloat(product.id)
						&& parseFloat(item.ratio) === parseFloat(product.default_item_sell.ratio)
						&& parseFloat(item.price) === parseFloat(product.default_item_sell.price)
						&& parseFloat(item.discount) === parseFloat(product.default_item_sell.discount)
						&& item.discount_type === product.default_item_sell.discount_type
					) {
						item_match = item_index; //หาสินค้าที่มีใน item
					}
					return null
				});
			}
			if (item_match === false) {
				payments[active_payment].item.push(item); //ถ้าไม่มีสินค้าใน item
			} else {
				window.item_select_index = item_match;
				payments[active_payment].item[item_match]._quantity = payments[active_payment].item[item_match]._quantity + 1; //ถ้ามีสินค้าใน item
				payments[active_payment].item[item_match].quantity = payments[active_payment].item[item_match]._quantity * payments[active_payment].item[item_match].ratio; //ถ้ามีสินค้าใน item
				// payments[active_payment] = this.suggestPromotion(payments[active_payment]);
			}

		}
		window.localStorage.setItem('payment', JSON.stringify(payments[active_payment]));
		window.localStorage.setItem("payments_pos_" + this.state.pos.id, JSON.stringify(payments));
		if (active_payment === false) {
			Helper.messageTopPOS({
				type: 'negative',
				message: 'โปรดเลือกบิล'
			});
			return null;
		}

		// this.state = {
		// 	...this.state,
		// 	payments: payments,
		// }
		window.$(".payment-segment").animate({scrollTop: window.$('.payment-segment').prop("scrollHeight")}, 100);
		this.Payments.current.setPayments(payments, item_match, active_payment);
		if (options && options.onSelected) {
			options.onSelected(this.Payments.current.getActivePayment().item)
		}

	}

	openCashier() {
		let data = {
			print_command: [
				{
					cmd: "custom",
					command: "sendRAWData2",
					data: "EBQAAAA="
				},
			],
			print_loop_delay: 20,
			printer_name: 'XP-80'
		};
		window.Global.ajax({
			url: 'http://localhost/print-service.php',
			method: 'POST',
			data: data,
			done: (responseJson2) => {
				console.log(responseJson2);

			}
		});
	}

	render() {
		if (!this.state.pos) {
			return <div className="ui active centered inline loader"/>
		}
		return (
			<div
				ref={(ref) => {
					if (!ref) return;
					this.$parent = window.$(ref);
				}}
				key={'ddd' + window.Global.getRandomInt(1, 99999999)}
				className="flex"
				style={{
					height: '100%',
					overflow: "hidden",
					flexShrink: 1,
				}}
			>

				{/*HEADER*/}
				<div id="HeaderTop_root"
				     style={{backgroundColor: 'white', padding: '1rem'}}
				     className="flex row wrap center-xs"
				>
					<div className={"flex row"}>
						{
							this.state.last_pos_shift
							&& this.state.last_pos_shift.type
							&& this.state.last_pos_shift.type === 'open_shift'
							&& !this.state.show_working_time ?
								<>
									{/*RIGHT HEADER*/}
									<div style={{position: 'absolute', right: '1rem', top: '1rem'}}>

										{/*<button className={"ui button custom-active-btn active massive"}*/}
										{/*        style={{padding: button_padding, fontSize: button_fontSize}}*/}
										{/*        onClick={() => {*/}
										{/*	        this.openCashier()*/}
										{/*        }}*/}
										{/*>*/}
										{/*	เปิดลิ้นชัก*/}
										{/*</button>*/}


										<Link to={"/v2/sale_orders/pos/history"}
										      className={"ui button custom-active-btn active massive"}
										      style={{padding: button_padding, fontSize: button_fontSize}}
										>
											ประวัติ
										</Link>
										{
											this.state.user ?
												<>
													<div className={"ui button basic icon massive"}>
														{
															this.state.user.name
														}
													</div>

													<div className={"ui button basic icon massive"}
													     onClick={() => {
														     Helper.posConfirmModal({
															     title: 'ออกจากระบบ',
															     content: "คุณต้องการออกจากระบบหรือไม่?",
															     cancel_text: 'ไม่ดำเนินการ',
															     approve_text: 'ออกจากระบบ',
															     onApprove: () => {
																     window.location = process.env.REACT_APP_DOMAIN + "/signout?redirect=%2Fv2%2Fsale_orders%2Fpos";
															     }
														     });

													     }}
													>
														<i className={"sign-out icon"}/>
													</div>
												</>
												: null
										}
									</div>
									{/*LEFT HEADER*/}
									<div
										style={{position: 'absolute', left: '1rem', top: '1rem', zIndex: 100}}>
										<div
											className="ui icon top left pointing dropdown button basic massive custom-header-left-top-btn"
											ref={(ref) => {
												window.$(ref).dropdown();
											}}
										>
											<i className="cogs icon"/>
											<div className="menu">
												<div className="item"
												     id={"item"}
												     onClick={() => {
													     window.Global.reactToDom(window.$('body'),
														     <POSCategoryPriorityModal
															     filter={this.Products.current.getFilter()}
															     onSuccessSwap={(filters) => {
																     this.Products.current.updateFilter(filters);
															     }}
															     setFilter={(filters) => {
																     this.Products.current.updateFilter(filters);
															     }}
															     fetchFilter={() => {
																     this.Products.current.fetchFilter();
															     }}
														     />
													     )
												     }}
												>จัดการหมวดหมู่
												</div>
												<div className="item"
												     id={"item"}
												     onClick={() => {
													     this.Products.current.toggleManageMode('product');
												     }}
												>
													จัดการสินค้า
												</div>
												<div className="ui divider" style={{margin: 0}}/>
												<Link to={"/v2/sale_orders/pos/daily-report"}
												      className={"item"}
												      id={"item"}
												      style={{padding: button_padding, fontSize: button_fontSize}}
												>
													สรุปยอดขาย
												</Link>
												<div className="ui divider" style={{margin: 0}}/>
												<div className="header flex row"
												     style={{padding: '1.5rem', fontSize: '1.5rem', margin: 0}}
												>
													Version
													<div className={"right floated"}>
														0.1.1
													</div>
												</div>
											</div>
										</div>

										<div className="ui icon top left pointing dropdown button basic massive"
										     ref={(ref) => {
											     if (window.$(ref).hasClass('loading')) {
												     return false;
											     }
											     window.$(ref).on('click', () => {
												     window.$(ref).addClass('loading');
												     window.location.reload();
											     })
										     }}
										>
											<i className="sync alternate icon"/>
										</div>
										<button className={"ui button basic massive"}
										        style={{padding: button_padding, fontSize: button_fontSize}}
										        onClick={() => {
											        this.callPOSSelector()
										        }}
										>
											{this.state.pos ? this.state.pos.name : 'POS'}
										</button>
										{
											this.state.last_pos_shift
											&& this.state.last_pos_shift.type
											&& this.state.last_pos_shift.type === 'open_shift' ?
												<button className={"ui button basic massive"}
												        style={{padding: button_padding, fontSize: button_fontSize}}
												        onClick={() => {
													        this.setState({
														        show_working_time: true,
													        });
												        }}
												>
													ปิดกะ
												</button>
												: null
										}
									</div>
								</>
								: null
						}

						<img className={"pos_logo"} src={process.env.REACT_APP_DOMAIN + '/assets/images/logo.png'}
						     alt={"Logo"}/>

					</div>
				</div>
				{/*CONTENT*/}
				<div className={"flex row"} style={{padding: '1rem', overflow: "hidden", height: '100%'}}>
					<div id="POS_viewRoot" className={"main-section col-xs-16 padded"}>
						{this.state.show_working_time ?
							<WorkingTime
								show_working_time={this.state.show_working_time}
								last_pos_shift={this.state.last_pos_shift}
								user={this.state.user}
								pos={this.state.pos}
								closeModal={() => {
									this.setState({
										show_working_time: false,
									}, () => {
										this.fetchPOS();
									})
								}}
								onSuccess={(last_pos_shift) => {
									this.setState({
										last_pos_shift: last_pos_shift,
										show_working_time: false,
									}, () => {
										this.fetchPOS();
									});
								}}
							/>
							: null
						}
						<div className={"flex row wrap padded"}
						     style={{
							     height: '100%',
						     }}>
							<div className={"main-section col-xs-16 col-lg-9 padded"}
							     style={{
								     height: '100%',
							     }}>
								{
									!this.state.is_show_table ?
										<Products ref={this.Products}
										          user={this.state.user}
										          pos={this.state.pos}
										          selectProduct={(product, options) => {
											          this.selectProduct(product, options)
										          }}
										          selected_items={
											          this.state.payments.filter((p) => {
												          return p.active
											          }).length > 0 ? this.state.payments.filter((p) => {
												          return p.active
											          })[0].item : false
										          }
										          relation_ship={this.Payments && this.Payments.current && this.Payments.current.getRelationShip() ? {...this.Payments.current.getRelationShip()} : {...this.state.pos.pos_default_payment.relationship}}
										/>
										: null
								}
								{
									this.state.is_show_table ?
										<SelectTable
											payments={this.Payments.current.getPayments()}
											onSelectedPayment={(payments) => {
												// console.log(payments);
												this.Payments.current.setPayments(payments)
											}}
											addPayment={(payments, payment) => {
												return this.addPayment(payments, payment);
											}}
										/>
										: null
								}
							</div>
							<div className={"right-section col-xs-16 col-lg-7 padded"} style={{height: '100%'}}>
								<Payments ref={this.Payments}
								          canvas_mode={this.state.canvas_mode}
								          is_show_table={this.state.is_show_table}
								          payments={this.state.payments}
								          pos={this.state.pos}
								          addPayment={(payments) => this.addPayment(payments)}
								          showSelectTable={(payments) => {
									          this.setState({
										          is_show_table: !this.state.is_show_table,
										          payments: payments,
									          }, () => {
										          if (!this.state.is_show_table) {
											          this.Products.current.fetchProduct();
										          }
									          })
								          }}
								          updateState={(state) => {
									          let _payments = state.payments.filter((p) => {
										          return p.active
									          });
									          let selected_item = false;
									          if (_payments.length > 0) {
										          selected_item = _payments[0].item
									          }
									          this.Products.current.updateSelectedItems(selected_item)
									          window.localStorage.setItem("payments_pos_" + this.state.pos.id, JSON.stringify(state.payments));
									          // this.state = {...state, ...this.state}
									          return null
								          }}
								          onUpdateRelationship={(state) => {
									          window.localStorage.setItem("payments_pos_" + this.state.pos.id, JSON.stringify(state.payments));
									          this.setState({
										          payments: state.payments
									          }, () => {
										          this.Products.current.fetchProduct();
										          this.Products.current.fetchFilter();
									          })
								          }}

								/>
							</div>
						</div>
					</div>
					<div id={"calculator_Root"} className={"main-section col-xs-16 col-lg-4 padded"}
					     style={{display: 'none'}}
					>
						<Calculator closeCalculator={() => closeCalculator()}/>
					</div>
				</div>
			</div>
		)
			;
	}
}

class WorkingTime extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			last_pos_shift: props.last_pos_shift,
			user: props.user || {},
			pos: props.pos,
			change_amount: 0,
			date: window.moment()._d,
			currentDateValue: window.moment().format('YYYY-MM-DD') + ',' + window.moment().format('YYYY-MM-DD'),
			currentDateReadable: window.moment().format('DD MMM YYYY - hh:mm:ss'),
			isLoadingBtn: false,
			manange_mode: false,
		}
	}

	closeModal() {
		this.props.closeModal()
	}

	onSubmitWiorkingTime() {
		let type = 'open_shift';
		if (this.state.pos && this.state.last_pos_shift && this.state.last_pos_shift.type === 'open_shift') {
			type = 'close_shift';
		}
		let data = {
			type: type,
			pos_id: this.state.pos.id,
			change_amount: this.state.change_amount,
		};
		// return;
		window.Global.ajax({
			url: process.env.REACT_APP_DOMAIN + '/api/pos/shift',
			method: 'POST',
			data: data,
			done: (responseJson) => {
				this.setState({
					change_amount: 0,
					isLoadingBtn: false,
				}, () => {
					window.localStorage.setItem("payments_pos_" + this.state.pos.id, "");
				});
				this.props.onSuccess(responseJson.pos_shift);
			}
		})
	}


	render() {
		return (
			<div className={"custom-modal working-time"}
			     ref={(ref) => this.$modal_working_time = window.$(ref)}
			     style={{zIndex: 10000, backgroundColor: '#f4f4f4'}}
			>
				<div className={"ui segment"}
				     style={{width: '100%', height: '100%', display: 'flex', flexDirection: 'column'}}>
					{/*HEADER*/}
					<div id="HeaderTop_root"
					     style={{marginBottom: '1rem', backgroundColor: 'white', padding: '1rem'}}
					     className="flex row wrap center-xs"
					>
						<div>
							{
								this.state.pos
								&& this.state.last_pos_shift
								&& this.state.last_pos_shift.type !== 'close_shift' ?
									<h1>ปิดกะ</h1>
									: <h1>เปิดกะ</h1>

							}
						</div>
					</div>
					<div style={{flex: 1}}>
						<div className={"flex row middle-xs"}>
							<h1>ผู้ดำเนินการ</h1>
							<div className={"title"}> {this.state.user.name || 'ไม่มีข้อมูล'}</div>
						</div>
						<div className={"flex row middle-xs"}>
							<h1>วันเวลาเปิดกะ</h1>
							<div className={"title"}>
								{
									this.state.pos
									&& this.state.last_pos_shift
									&& this.state.last_pos_shift.type === 'close_shift' ?
										<div>{this.state.currentDateReadable}</div>
										:
										this.state.pos
										&& this.state.last_pos_shift ?
											window.Global.getDateThai(this.state.last_pos_shift.date_created, {is_show_time: true})
											: null

								}
							</div>
						</div>
						{
							this.state.pos
							&& this.state.last_pos_shift
							&& this.state.last_pos_shift.type !== 'close_shift' ?
								<div className={"flex row middle-xs"}>
									<h1>วันเวลาปิดกะ</h1>
									<div className={"title"}>
										<div>{this.state.currentDateReadable}</div>
									</div>
								</div>
								: null
						}
						{
							this.state.pos
							&& this.state.last_pos_shift
							&& this.state.last_pos_shift.type !== 'close_shift' ?
								<div className={"flex row middle-xs"}>
									<h1>จำนวนเงินทอนตอนเปิดกะ</h1>
									<div className={"title"}>
										<div>{this.state.last_pos_shift.change_amount.format(2, 3, {pretty: false})}</div>
									</div>
								</div>
								: null
						}
						<div className={"flex"} style={{marginBottom: '1rem'}}>
							<h1>
								จำนวนเงินทอน
							</h1>
							<div style={{textAlign: 'center'}}>
								<input className={"pos-price-input border"}
								       style={{color: '#02B04E', borderWidth: 2}}
								       defaultValue={this.state.change_amount}
								       ref={(ref) => {
									       this.$total_price_input = window.$(ref);
									       callCalculator(ref);
									       window.$(ref).off('change keyup').on('change keyup', (e) => {
										       let amount = e.target.value;
										       if (amount !== undefined) {
											       amount = amount.replace(/,/g, '');
											       this.setState({
												       change_amount: amount
											       })
										       }
									       });
								       }}
								/>
							</div>
						</div>

					</div>
					<div className={"flex row"}>
						{
							this.state.last_pos_shift
							&& this.state.last_pos_shift.type !== 'close_shift' ?
								<button
									onClick={() => {
										this.closeModal();
									}}
									className="ui approve button basic fluid custom-submit-btn"
									style={{width: 300, marginRight: '1.8rem'}}
								>ยกเลิก</button>
								: null
						}
						<button className="ui approve button green fluid custom-submit-btn"
						        style={{
							        cursor: 'pointer',
							        marginRight: 0
						        }}
						        type={"submit"}
						        onClick={() => {
							        if (!this.state.change_amount) {
								        Helper.posConfirmModal({
									        title: 'ยืนยันปิดกะ',
									        content: "ยืนยันเปิดกะที่เงินทอน 0 บาท หรือไม่?",
									        cancel_text: 'ไม่ดำเนินการ',
									        approve_text: 'ยืนยัน',
									        onApprove: () => {
										        this.onSubmitWiorkingTime()
									        }
								        });
								        return null;
							        }
							        if (this.state.change_amount) {
								        this.onSubmitWiorkingTime();
							        }

						        }}
						>
							{
								this.state.last_pos_shift
								&& this.state.last_pos_shift.type !== 'close_shift' ?
									"ปิดกะ"
									: "เปิดกะ"
							}
						</button>
					</div>
				</div>

			</div>
		);
	}
}

class SelectTable extends React.Component {
	constructor() {
		super();
		this.state = {
			is_loading: true,
			canvas_object: [
				{
					title: 'โต๊ะ 1',
					type: 'table',
					table_type: '4-seats',
					top: 50,
					left: 50,
					seats: 4,
					arrived: false,
					id: 1,
				},
				{
					title: 'โต๊ะ 2',
					type: 'table',
					table_type: '2-seats',
					top: 50,
					left: 300,
					seats: 2,
					scaleX: 0.5,
					scaleY: 0.5,
					arrived: true,
					id: 2,
				},
				{
					title: 'โต๊ะ 3',
					type: 'table',
					table_type: '4-seats',
					top: 280,
					left: 350,
					seats: 3,
					arrived: true,
					id: 3,
				},
				{
					type: 'building_plan',
					points: [
						{x: 5, y: 5, canvas_obj_type: "polygon_base"},
						{x: 522, y: 9, canvas_obj_type: "polygon_base"},
						{x: 663, y: 491, canvas_obj_type: "polygon_base"},
						{x: 113, y: 491, canvas_obj_type: "polygon_base"}]
				}
			]
		}
	}

	componentDidMount() {
		this.setState({
			is_loading: false,
			canvas_width: this.$parent.find('#canvas-frame').width(),
			canvas_height: this.$parent.find('#canvas-frame').height(),
		}, () => {
			this.createCanvas();
		})
	}

	selectTable(obj) {
		if (obj.canvas_obj_type === 'building_plan') {
			return;
		}
		let new_uid = "online-" + obj.payment_id
		let match_payment = this.props.payments.filter((pay) => {
			return pay.payment_uid === new_uid
		}).length;
		let payments = [...this.props.payments];
		if (match_payment === 0) {
			payments = this.props.addPayment(this.props.payments, {uid: "online-" + obj.payment_id})
		}
		payments.map((payment, payment_i) => {
			payments[payment_i].active = payment.payment_uid === new_uid;
			return false;
		});
		this.props.onSelectedPayment(payments);
	}

	createCanvas() {
		this.__canvas = new window.fabric.Canvas(window.$('#canvas').get(0), {
			preserveObjectStacking: true,
		});

		let canvas = this.__canvas;
		for (let i = 0; i < this.state.canvas_object.length; i++) {
			if (this.state.canvas_object[i].type === 'table') {
				this.addTable(this.state.canvas_object[i]);
			}
			if (this.state.canvas_object[i].type === 'building_plan') {
				this.createBuildingPlan(this.state.canvas_object[i].points);
			}
		}

		canvas.off('mouse:up').on('mouse:up', (e) => {
			// อัพเดทข้อมูล Text
			if (e.target) {
				let obj = this.getObject(e.target);
				this.selectTable(obj);
			}
		});
		canvas.off('selection:cleared').on('selection:cleared', (e) => {
			// this.POSCrateBillSetting.current.clearSelected();
		});
		canvas.off('selection:created').on('selection:created', (e) => {
			if (e.selected.length > 0) {
				let obj = this.getObject(e.selected[0]);
				this.selectTable(obj);
			}

		});

	}

	getObject(target) {
		let obj = {
			left: target.left,
			top: target.top
		};
		if (target.payment_id) {
			obj.payment_id = parseFloat(target.payment_id);
		}
		if (target.translateY) {
			obj.translateY = parseFloat(target.translateY);
		}
		if (target.translateX) {
			obj.translateX = parseFloat(target.translateX);
		}
		if (target.scaleX) {
			obj.scaleX = parseFloat(target.scaleX);
		}
		if (target.scaleY) {
			obj.scaleY = parseFloat(target.scaleY);
		}
		if (target.zoomX) {
			obj.zoomX = parseFloat(target.zoomX);
		}
		if (target.zoomY) {
			obj.zoomY = parseFloat(target.zoomY);
		}
		if (target.canvas_obj_type) {
			obj.canvas_obj_type = target.canvas_obj_type;
		}
		if (target._objects) {
			target._objects.map((object) => {
				if (object.canvas_obj_type === 'group_detail') {
					object._objects.map((_object) => {
						if (_object.canvas_obj_type === 'Text') {
							obj.title = _object.text;
						}
						if (_object.table_type) {
							obj.type = _object.table_type;
						}
						if (_object.seats) {
							obj.seats = _object.seats;
						}
						return false;
					})
				}
				return false;
			});
		}
		return obj
	}

	addTable(obj) {
		let canvas = this.__canvas;
		let text = new window.fabric.Text(obj.title + '', {
			fontSize: 30,
			originX: 'center',
			originY: 'center',
			// backgroundColor: 'green',
			fontFamily: "Kanit",
			canvas_obj_type: 'Text',
			table_type: obj.type,
			seats: obj.seats,
			// color: '#fff',
			fill: '#000',
			padding: 5,
			selectable: false,
		});
		let details_group = new window.fabric.Group([text], {
			left: 0,
			top: 0,
			canvas_obj_type: 'group_detail',
			width: 260,
			height: 260,
			hasRotatingPoint: false,
			lockUniScaling: true,
			lockSkewingX: true,
			lockSkewingY: true,
			lockRotation: true,
		});
		window.fabric.Object.prototype.transparentCorners = false;
		window.fabric.Object.prototype.cornerColor = 'rgba(0,0,0,1)';
		window.fabric.Object.prototype.cornerStyle = 'circle';
		window.fabric.Object.prototype.borderColor = '#ccc';
		window.fabric.Object.prototype.hasControls = true;


		// จำนวนที่นั่ง
		let person = new window.fabric.Text(obj.seats + " คน", {
			fontSize: 18,
			left: 85,
			top: 80,
			fontFamily: "Kanit",
			canvas_obj_type: 'person',
			table_type: obj.type,
			fill: '#000',
			selectable: false,
		});

		let arrived = false;
		// ถ้ามีคนนั่งแล้ว
		if (obj.arrived) {
			window.fabric.Image.fromURL(icon_img, (_icon_img) => {
				_icon_img.set({
					canvas_obj_type: 'icon_image',
					left: 160,
					top: 80,
				})
				_icon_img.scaleToWidth(20);
				arrived = _icon_img;
			});
		}
// เซ็ทรูป
		let table_img = table_4_img;
		if (obj.table_type === '2-seats') {
			table_img = table_2_img;
		}
// อัพรูปลงใน canvas
		window.fabric.Image.fromURL(table_img, (_table_img) => {
			_table_img.set({
				canvas_obj_type: 'table_image',
				left: 22,
				top: 22,
			})
			_table_img.scale(0.6);
			let group_array = [_table_img, details_group, person]
			if (arrived) {
				group_array.push(arrived)
			}

			let group_obj = {
				left: parseFloat(obj.left) || 50,
				top: parseFloat(obj.top) || 50,
				canvas_obj_type: 'table',
				payment_id: obj.id,
				borderColor: 'green',
				width: 200,
				height: 200,
				hasControls: false,
				draggable: false,
				lockMovementY: true,
				lockRotation: true,
				lockMovementX: true,
				lockScalingX: true,
				lockScalingY: true,
				lockSkewingX: true,
				lockSkewingY: true,
				lockUniScaling: true,
				// selectable: false,
				// evented: false,
				hoverCursor: 'pointer',
				hasRotatingPoint: false,
				// transparentCorners: true,
			}
			if (obj.scaleY) {
				group_obj.scaleY = parseFloat(obj.scaleY);
			}
			if (obj.scaleX) {
				group_obj.scaleX = parseFloat(obj.scaleX);
			}
			if (obj.translateY) {
				group_obj.translateY = parseFloat(obj.translateY);
			}
			if (obj.translateX) {
				group_obj.translateX = parseFloat(obj.translateX);
			}
			if (obj.zoomY) {
				group_obj.zoomY = parseFloat(obj.zoomY);
			}
			if (obj.zoomX) {
				group_obj.zoomX = parseFloat(obj.zoomX);
			}

			let group = new window.fabric.Group(group_array, group_obj);
			group.setControlsVisibility({mtr: false});
			let options = {};
			let new_uid = "online-" + obj.id
			let match_payment = this.props.payments.filter((pay) => {
				return pay.active === true
					&& pay.payment_uid === new_uid
			}).length;
			if (match_payment > 0) {
				options.active_object = true;
			}
			this.addCanvas(canvas, group, options);
		});

		// canvas.renderAll();
	}

	createBuildingPlan(points, options) {
		let canvas = this.__canvas;
		let polygon = new window.fabric.Polygon(points, {
			canvas_obj_type: 'building_plan',
			fill: '#ccc',
			// selectionBackgroundColor: '#ccc',
			opacity: options && options.opacity ? options.opacity : 0.3,
			// hasBorders: false,
			hasControls: false,
			draggable: false,
			lockMovementY: true,
			lockRotation: true,
			lockMovementX: true,
			lockScalingX: true,
			lockScalingY: true,
			lockSkewingX: true,
			lockSkewingY: true,
			lockUniScaling: true,
			selectable: false,
			// evented: false,
			hoverCursor: 'default',
			hasRotatingPoint: false,
		});
		this.addCanvas(canvas, polygon, {
			send_to_back: true,
			removePoint: true,
			removePolygon: options && options.delete_new_object
		});
	}

	addCanvas(canvas, object, options) {
		canvas.add(object);
		if (options && options.active_object) {
			canvas.setActiveObject(object);
		}
		if (options && options.send_to_back) {
			canvas.sendToBack(object);
		}
		if (options && options.bring_to_front) {
			canvas.bringToFront(object);
		}
		if (options && options.onSuccess) {
			options.onSuccess(canvas.getActiveObject());
		}
		let obj = canvas.getObjects();
		if (options && options.removePoint) {
			for (let i in obj) {
				if (obj[i].canvas_obj_type === 'point') {
					canvas.remove(obj[i]);
				}
			}
		}
		if (options && options.removePolygon) {
			let _building_plan_obj = [];
			for (let i in obj) {
				if (obj[i].canvas_obj_type === 'building_plan') {
					_building_plan_obj.push(obj[i]);
				}
			}
			canvas.remove(_building_plan_obj[0]);

		}
		// console.log(canvas.getObjects());

	}

	render() {
		return (
			<>
				<div
					ref={(ref) => {
						this.$parent = window.$(ref);
					}}
					className="ui padded segments flex"
					style={{
						height: '100%',
					}}
				>
					<div className={this.state.is_loading ? "ui segment flex loading" : "ui segment flex"}
					     style={{
						     height: '100%',
						     overflow: 'hidden',
						     padding: 0,
					     }}>
						<div style={{
							flex: 1,
							padding: '1rem',
							overflowY: 'auto',
							overflowX: 'hidden',
						}}>
							<div id={"canvas-frame"} style={{height: '100%'}}>
								<canvas id="canvas" width={this.state.canvas_width}
								        height={this.state.canvas_height}
								        style={{border: '1px solid #f4f4f4'}}
								/>
							</div>
						</div>
					</div>
				</div>
			</>
		);
	}
}

class Products extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			products: [],
			user: props.user || {},
			limit: 12,
			page: 1,
			search_query: '',
			search_query_barcode: '',
			search_query_barcode_or_serial_number: '',
			is_loading: true,
			is_show_next_button: false,
			filter: [],
			filter_id: false,
			search_mode: 'name',
			filter_manage_mode: false,
			product_manage_mode: false,
			selected_items: props.selected_items || []
		};
	}

	updateSelectedItems(selected_items) {
		this.setState({
			selected_items: selected_items,
		})
	}

	toggleManageMode(mode) {
		if (!mode) {
			return;
		}
		if (mode === 'filter') {
			this.setState({
				filter_manage_mode: !this.state.filter_manage_mode,
			})
		}
		if (mode === 'product') {
			this.setState({
				product_manage_mode: !this.state.product_manage_mode,
			})
		}
	}

	getFilter() {
		return this.state.filter;
	}

	updateFilter(update_filter) {
		this.setState({
			filter: update_filter
		})
	}

	fetchFilter() {
		let data = {
			type: 'product_category_for_pos',
			all: true
		}
		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/filter',
			data: data,
			done: (responseJson) => {
				let filter = [...responseJson.filter];
				let storage_filter = window.localStorage.getItem("filter_priority") && window.localStorage.getItem("filter_priority") !== "" ? JSON.parse(window.localStorage.getItem("filter_priority")) : [];
				if (storage_filter.length > 0) {
					responseJson.filter.map((item, item_i) => {
						storage_filter.map((_storage_filter, _storage_filter_i) => {
							if (item.id === _storage_filter.id) {
								filter[item_i].priority = _storage_filter.priority;
							}
							return false;
						})
						return false;
					})
					filter.map((_filter, _filter_i) => {
						if (!_filter.priority) {
							filter[_filter_i].priority = 0;
						}
						return false;
					})
					filter.sort((a, b) => {
						return a.priority - b.priority
					})
				}
				this.setState({
					filter: filter
				})
			}
		})
	}

	fetchProduct() {
		let data = {};
		data.is_pos = 1;
		data.limit = this.state.limit;
		data.page = this.state.page;
		data.search_query = this.state.search_query;
		data.search_query_barcode = this.state.search_query_barcode;
		data.request_data_product_barcode = 1;
		data.for_relationship_id = this.props.relation_ship.id;
		if (this.state.filter_id) {
			data.filter_product_category_for_pos_filter_id = this.state.filter_id;
		}
		data.from_device = 'mobile';

		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/product',
			data: data,
			done: (responseJson) => {
				// console.log(responseJson);
				let products = [...this.state.products];
				products = products.concat(responseJson.product);
				let is_show_next_button = false;
				if (responseJson.count > products.length) {
					is_show_next_button = true;
				}
				this.setState({
					is_loading: false,
					products: products,
					is_show_next_button: is_show_next_button,
				}, () => {
					if (this.loading_next) {
						this.loading_next.removeClass('loading');
					}
				})
			}
		})
	}

	// onSortEnd({oldIndex, newIndex}) {
	// 	console.log(oldIndex);
	// 	console.log(newIndex);
	// 	let product =
	// 	// let filters = [...this.state.products];
	// 	// let old_obj = this.state.products[oldIndex];
	//
	// 	window.Global.ajax({
	// 		method: 'PUT',
	// 		url: process.env.REACT_APP_DOMAIN + '/api/v1/filter_product_category_for_pos',
	// 		data: data,
	// 		done: (responseJson) => {
	// 			console.log(responseJson);
	// 		}
	// 	})
	// }


	render() {
		let active_filter = this.state.filter.filter((_filter) => {
			return _filter.id === this.state.filter_id
		})[0];
		return (
			<>
				<div className="ui padded segments flex"
				     style={{
					     height: '100%',
				     }}>
					<div className={"ui segment"} id={"product-header"}>
						<div className={"flex row middle-xs"}>
							{/*<button className={"ui button active"}>ทั้งหมด</button>*/}
							<h1 className={"ui header"} style={{marginTop: 0, marginBottom: 0}}>
								{
									!this.state.search_query
									&& !this.state.search_query_barcode ?
										"สินค้าทั้งหมด"
										: null
								}
								{
									this.state.search_query
									&& !this.state.search_query_barcode ?
										"ค้นหาชื่อสินค้า : " + this.state.search_query
										: null
								}
								{
									!this.state.search_query
									&& this.state.search_query_barcode ?
										"ค้นหาบาร์โค้ด : " + this.state.search_query_barcode
										: null
								}
								{
									active_filter ?
										<div className={"ui sub header"}>
											{"หมวดหมู่ " + active_filter.name}
										</div>
										: null
								}
							</h1>
							<div className="right floated flex row">

								<button className={"search-btn-icon"}
								        style={{marginRight: '1rem'}}
								        onClick={() => {
									        let value = "name";
									        if (this.state.search_mode === 'name') {
										        value = "barcode"
									        }
									        if (value === "name") {
										        this.search_name.show();
										        this.search_barcode.hide();
										        this.search_barcode.val('');
									        }
									        if (value === "barcode") {
										        this.search_name.hide();
										        this.search_name.val('');
										        this.search_barcode.show();
									        }
									        this.setState({
										        search_mode: value
									        })
								        }}

								>
									{
										this.state.search_mode === 'name' ?
											<i className={"tag icon"}/>
											: <i className={"barcode icon"}/>
									}
								</button>
								<form
									ref={(ref) => {
										this.search_form = window.$(ref)
									}}
									onSubmit={(e) => {
										e.preventDefault();
										let data = this.search_form.serializeObject();
										this.setState({
											...data,
											products: [],
											page: 1,
											is_loading: true,
										}, () => {
											this.fetchProduct()
										})
									}}
								>
									<div className="ui action input massive">
										<input type="text" name={"search_query"} placeholder="ค้นหาจากชื่อสินค้า"
										       ref={(ref) => {
											       this.search_name = window.$(ref);
										       }}/>
										<input type="text" name={"search_query_barcode"}
										       placeholder="ค้นหาจากบาร์โค้ด" ref={(ref) => {
											this.search_barcode = window.$(ref);
										}} style={{display: 'none'}}/>

										<button className="ui button"
										        style={{padding: button_padding, fontSize: button_fontSize}}
										        type={"submit"}>ค้นหา
										</button>
									</div>
								</form>
							</div>
						</div>
					</div>
					<div className={"ui segment"}>
						<div className={"flex row"}>
							<div className={'col-lg-16'}>
								<Slider
									ref={(ref) => this.slider = ref}
									dots={5}
									infinite={false}
									speed={500}
									slidesToShow={4}
									slidesToScroll={1}
									arrows={false}
									variableWidth={true}
								>
									<div>
										<div style={{marginRight: '1rem'}}>
											<button
												style={{padding: button_padding, fontSize: button_fontSize}}
												className={!this.state.filter_id ? "ui button custom-active-btn massive active" : "ui button basic massive"}
												onClick={() => {
													this.setState({
														filter_id: false,
														products: [],
														is_loading: true,
														page: 1
													}, () => {
														this.fetchProduct();
													})
												}}
											>
												ทั้งหมด
											</button>
										</div>
									</div>
									{
										this.state.filter.map((filter, filter_i) => {
											return (
												<div key={filter_i}>
													<div style={{marginRight: '1rem'}}>
														<div
															onClick={() => {

																this.setState({
																	filter_id: filter.id,
																	products: [],
																	is_loading: true,
																	page: 1
																}, () => {
																	this.fetchProduct();
																})
															}}
															style={{padding: button_padding, fontSize: button_fontSize}}
															className={this.state.filter_id && this.state.filter_id === filter.id ? "ui button custom-active-btn massive active" : "ui button basic massive"}
														>
															{
																this.state.filter_manage_mode ?
																	<div
																		className={"ui label orange fixed top right"}>กดเพื่อแก้ไข</div>
																	: null
															}
															{filter.name}
														</div>
													</div>
												</div>
											)
										})
									}
								</Slider>
							</div>
						</div>
					</div>
					<div className={"ui segment flex"}
					     style={{
						     height: '100%',
						     overflow: 'hidden',
						     padding: 0,
					     }}>
						<div style={{
							flex: 1,
							padding: '1rem',
							overflowY: 'auto',
							overflowX: 'hidden',
						}}>
							{/*PRODUCTS*/}
							{
								this.state.is_loading ?
									<div className={"column padded"}>
										<div className={"ui active centered inline loader huge"}/>
									</div>
									: null
							}
							{
								!this.state.is_loading
								&& this.state.products.length > 0 ?
									<>
										{
											!this.state.is_loading
											&& this.state.products.length > 0 ?
												<SortableContainer
													onSortEnd={({oldIndex, newIndex}) => {
														let product = this.state.products[oldIndex];
														// console.log(filter);
														// console.log(product);
														// console.log(newIndex);
														let products = [...this.state.products];
														products.splice(oldIndex, 1)
														let new_products = [];
														products.map((_product, _product_i) => {
															if (_product_i === newIndex && newIndex === 0) {
																new_products.push(product)
															}
															new_products.push(_product);
															if (_product_i === (newIndex - 1) ||
																(newIndex === products.length && (_product_i + 1) === products.length)
															) {
																new_products.push(product)
															}
															return false;
														})

														let data = {
															filter_id: active_filter.id,
															new_index: newIndex + 1,
															old_index: oldIndex + 1,
															product_id: product.id,
														};
														this.setState({
															products: new_products,
														})
														window.Global.ajax({
															method: 'PUT',
															url: process.env.REACT_APP_DOMAIN + '/api/v1/filter_product_category_for_pos',
															data: data,
															done: (responseJson) => {
																return true;
															}
														});
													}}
													useDragHandle
													axis={'xy'}
												>
													<div className={"flex row wrap padded four column computer"}>
														{
															this.state.products.map((product, product_i) => {
																let count_selected_item = 0;
																this.state.selected_items.map((item, item_i) => {
																	if (item.product_id === product.id) {
																		count_selected_item += parseFloat(item._quantity)
																	}
																	return false;
																})
																return (
																	<SortableItem
																		key={`item-${product_i}`}
																		index={product_i}
																	>
																		<div className={"column padded pos_item"}
																		     style={{position: 'relative'}}>
																			{
																				this.state.product_manage_mode
																				&& this.state.filter_id ?
																					<DragHandle
																						key={`item-${product_i}`}>
																						<div
																							className={"fixed top left"}
																							style={{
																								zIndex: 2,
																								left: 13
																							}}>
																							<div
																								className={"circular ui icon button"}>
																								<i className={"icon arrows alternate"}/>
																							</div>
																						</div>
																					</DragHandle>
																					: null
																			}
																			<div className="pos_item_custom"
																			     onClick={() => {
																				     if (this.state.product_manage_mode) {
																					     window.Global.reactToDom(
																						     window.$('body'),
																						     <POSProductCategoryModal
																							     product={product}
																							     pos={this.props.pos}
																							     fetchProduct={() => {
																								     if (this.state.filter_id) {
																									     this.setState({
																										     products: []
																									     }, () => this.fetchProduct());
																								     }
																							     }}
																						     />
																					     );
																					     return false;
																				     }
																				     this.props.selectProduct(product, {
																					     onSelected: (items) => {
																						     this.setState({
																							     selected_items: items
																						     })
																					     }
																				     });
																			     }}
																			>
																				<div className="image pos_frame"
																				     style={{background: '#bcbec0'}}>
																					{
																						this.state.product_manage_mode ?
																							<div
																								className={"ui label orange fixed top right"}
																								style={{zIndex: 2}}>กดเพื่อเลือกหมวดหมู่</div>
																							: null
																					}
																					{
																						count_selected_item > 0 ?
																							<div
																								style={{
																									fontSize: '1.3rem',
																									textAlign: 'center',
																									minWidth: 26,
																									padding: '0.3rem 0.5rem'
																								}}
																								className={"ui label red fixed top right"}>
																								{count_selected_item}
																							</div>
																							: null
																					}
																					<img
																						src={product.product_image_file_upload.url}
																						style={{maxWidth: '100%'}}
																						alt={"Product"}/>
																				</div>
																				<div className="content"
																				     style={{padding: '0.5rem'}}>
																					<div
																						className="description pos_title">
																						{product.name}
																					</div>
																					<div
																						className="pos_price"
																						style={{marginTop: 5}}
																					>
																						฿{product.default_item_sell.price.format(2)}
																					</div>
																				</div>
																			</div>
																		</div>
																	</SortableItem>
																);
															})
														}
													</div>
												</SortableContainer>
												: null
										}

										{
											this.state.is_show_next_button ?
												<button className={"ui button massive fluid"}
												        style={{
													        padding: button_padding,
													        fontSize: button_fontSize,
													        marginTop: '1rem',
													        marginBottom: '1rem'
												        }}
												        ref={(ref) => {
													        this.loading_next = window.$(ref);
												        }}
												        onClick={() => {
													        if (this.loading_next.hasClass('loading')) {
														        return false;
													        }
													        this.loading_next.addClass('loading');
													        this.setState({
														        page: this.state.page + 1,
													        }, () => {
														        this.fetchProduct();
													        })
												        }}
												>
													ดูเพิ่ม
												</button>
												: null
										}
									</>
									: null
							}
							{
								!this.state.is_loading
								&& this.state.products.length === 0 ?
									<div className={"flex padded one column computer"}>
										<div className={"center-xs middle-xs column padded"}>
											<p style={{fontSize: allpage_fontSize}}>ไม่พบข้อมูลสินค้า</p>
										</div>
									</div>
									: null
							}
						</div>
						{
							this.state.product_manage_mode ?
								<div style={{padding: '1rem'}}>
									<button className={"ui button massive fluid"}
									        style={{
										        padding: button_padding,
										        fontSize: button_fontSize
									        }}
									        onClick={() => {
										        this.toggleManageMode('product')
									        }}
									>
										ปิดการแก้ไข
									</button>
								</div>
								: null
						}
					</div>
				</div>
			</>
		);
	}
}

class Payments extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			payments: [...props.payments] || [],
		}
	}

	getRelationShip() {
		let _payment = false;
		this.state.payments.map((payment, payment_i) => {
			if (payment.active) {
				_payment = payment;
				_payment.index = payment_i;
			}
			return null;
		})
		return _payment.relationship;
	}

	setPayments(payments) {
		this.setState({
			payments: payments,
		}, () => {
			window.localStorage.setItem("payments_pos_" + this.props.pos.id, JSON.stringify(this.state.payments));
		})
	}

	getPayments() {
		return this.state.payments;
	}

	getActivePayment() {
		let _payment = false;
		this.state.payments.map((payment, payment_i) => {
			if (payment.active) {
				_payment = payment;
				_payment.index = payment_i;
			}
			return null;
		})
		return _payment;
	}

	onSuccessPayment(responseJson, payments) {
		Helper.messageTopPOS({
			type: 'positive',
			message: 'ชำระเงินสำเร็จ'
		});
		window.Global.reactToDom(window.$('body'),
			<PaymentModalDetails
				{...responseJson}
				run_printing={
					localStorage.getItem('is_auto_print_receipt')
					&& localStorage.getItem('is_auto_print_receipt') === '1'
				}
				onSaleOrderCancle={(_payment, options) => {
					onSaleOrderCancle(_payment, options)
				}}
			/>
		)
		let count_active_payments = payments.filter((_payment, payments_index) => {
			return _payment.active
		}).length;
		if (payments.length > 0 && count_active_payments === 0) {
			payments[0].active = true;
		}
		this.setState({
			payments: payments.length > 0 ? payments : this.props.addPayment(payments),
			isLoadingBtn: false,
		}, () => {
			this.props.updateState({payments: this.state.payments})
			window.localStorage.setItem("payments_pos_" + responseJson.payment.payment_pos.pos_id, JSON.stringify(this.state.payments));
		})
	}


	render() {
		let active_payment = this.getActivePayment();
		return (
			<div className="ui padded segments stciky-segment"
			     style={{
				     display: "flex",
				     flexDirection: 'column',
				     height: '100%'
				     // height: window.$('.main-section').height(),
			     }}
			>
				<div className="ui segment">
					{
						this.props.canvas_mode ?
							<button className={"ui button basic massive icon"}
							        style={{padding: button_padding, fontSize: button_fontSize}}
							        type={"button"}
							        onClick={() => {
								        this.props.showSelectTable(this.state.payments)
							        }}
							>
								{
									this.props.is_show_table ?
										"ยกเลิก"
										: "เลือกโต๊ะ"
								}
							</button>
							: null
					}
					{
						!this.props.split_mode
						&& !this.props.canvas_mode ?
							<div className={"bill-list flex row wrap"}>
								<button className={"ui button basic massive icon"}
								        style={{padding: button_padding, fontSize: button_fontSize}}
								        type={"button"}
								        onClick={() => {
									        this.setState({
										        payments: this.props.addPayment(this.state.payments),
									        }, () => {
										        this.props.updateState({payments: this.state.payments})
									        })
								        }}
								>
									<i className={"icon plus"}/>
								</button>
								<div className={"flex row wrap"} style={{flexShrink: 1}}>
									{
										this.state.payments.length > 0 ?
											this.state.payments.map((payment, payment_index) => {
												if (!payment.payment_uid || (payment.payment_uid && payment.payment_uid.indexOf('manual') === -1)) {
													return null
												}
												return (
													<button
														key={payment_index}
														className={payment.active ? "ui button icon massive custom-active-btn active custom-button" : "ui button icon basic massive custom-button"}
														style={{padding: button_padding, fontSize: button_fontSize}}
														type={"button"}

														onClick={() => {
															let payments = [...this.state.payments];
															this.state.payments.map((_payment, _payment_i) => {
																payments[_payment_i].active = _payment.payment_uid === payment.payment_uid;
																return null;
															})
															this.setState({
																payments: payments,
															}, () => {
																this.props.updateState({payments: this.state.payments})
															})
														}}
													>
														{payment_index + 1}
													</button>
												)
											})
											: null
									}
								</div>
								{
									this.state.payments.length > 1 ?
										<button className={"ui button icon massive right floated basic"}
										        style={{padding: button_padding, fontSize: button_fontSize}}
										        onClick={() => {
											        Helper.posConfirmModal({
												        title: 'ต้องการยกเลิกบิลนี้หรือไม่ ?',
												        content: 'โปรดยืนยันยกเลิกบิล',
												        cancel_text: 'ไม่ดำเนินการ',
												        approve_text: 'ลบบิล',
												        onApprove: () => {
													        console.log("Approve");
													        let active_index = active_payment.index;
													        let _payments = [...this.state.payments];
													        if (_payments.length === 1) {
														        return null
													        }
													        _payments.splice(active_index, 1); //REMOVE CATEGORY
													        let count_active_payment = _payments.filter((payment) => {
														        return payment.active
													        }).length;
													        if (count_active_payment === 0) {
														        if (_payments[active_index - 1]) {
															        _payments[active_index - 1].active = true;
														        }
														        if (!_payments[active_index - 1]) {
															        _payments[active_index].active = true;
														        }
													        }
													        this.setState({
														        payments: _payments,
													        }, () => {
														        this.props.updateState({payments: this.state.payments})
													        })
												        },
											        });
										        }}
										>
											<i className={"icon trash alternate"} style={{margin: 0}}/>
										</button>
										: null
								}

							</div>
							: null
					}
					{
						this.props.split_mode ?
							this.props.title ?
								<h2 className={"ui header"}>{this.props.title}</h2>
								: ""
							: null
					}

				</div>
				{
					this.state.payments.length > 0 ?
						this.state.payments.map((payment, payment_index) => {
							let _payment_index = payment_index;
							if (!payment.active) {
								return false
							}
							return <Payment
								ref={(ref) => {
									this['$payment' + payment_index] = window.$(ref);
								}}
								active_payment={active_payment}
								split_mode={this.props.split_mode}
								key={payment_index}
								payment={payment}
								pos={this.props.pos}
								splitBillPayment={() => {
									let clone_payment = cloneDeep(payment);
									window.Global.reactToDom(
										window.$('#POS_viewRoot'),
										<SplitBillPayment
											default_payment={clone_payment}
											pos={this.props.pos}
											updateSelectedItems={(selected_item) => {
												this.props.updateSelectedItems(selected_item)
											}}
											onUpdatePayment={(_payment) => {
												let payments = [...this.state.payments];
												payments[payment_index] = _payment;
												this.setState({
													payments: payments
												}, () => {
													this.props.updateState(this.state);
												})
											}}
											fetchProduct={() => {
												this.props.fetchProduct();
											}}
											addPayment={(payments) => {
												this.props.addPayment(payments)
											}}
											onSuccessPayment={(responseJson, _payment) => {
												let payments = [...this.state.payments];
												if (_payment.item.length === 0) {
													payments.splice(payment_index, 1);
												}
												if (_payment.item.length > 0) {
													payments[payment_index] = _payment;
												}
												this.onSuccessPayment(responseJson, payments)
											}}
										/>
									);
								}}
								updatePayment={(_payment) => {
									let payments = [...this.state.payments];
									payments[_payment_index] = {..._payment};
									this.setState({
										payments: payments
									}, () => {
										if (!this.props.split_mode) {
											window.localStorage.setItem('payment', JSON.stringify(_payment));
										}
										this.props.updateState({payments: this.state.payments})
									});

								}}
								onSuccessPayment={(responseJson) => {
									let payments = [...this.state.payments];
									payments.splice(this.getActivePayment().index, 1);
									this.onSuccessPayment(responseJson, payments)
								}}
								onUpdateRelationship={(payment) => {
									let payments = [...this.state.payments];
									payments[_payment_index] = {...payment};
									// window.localStorage.setItem("payments_pos_" + this.state.pos.id, JSON.stringify(state.payments));
									this.setState({
										payments: payments
									}, () => {
										this.props.onUpdateRelationship(this.state);
									})
								}}
							/>
						})
						: null
				}


			</div>
		);
	}
}

class Payment extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			payment: {...props.payment},
		}
	}

	setPayment(payment) {
		this.setState({
			payment: payment,
		})
	}

	runEffect(item_index) {
		let $node = false;
		if (item_index !== undefined) {
			$node = this.$paymentSegment.find('.item-list:nth-child(' + (item_index + 1) + ')');
		} else {
			$node = this.$paymentSegment.find('.item-list:last-child');
		}
		$node.css({backgroundColor: '#ffff0082'});
		let _settime = setTimeout(() => {
			$node.css({backgroundColor: ''});
			clearTimeout(_settime);
		}, 300)
	}

	increaseItem(item) {
		let _payment = {...this.state.payment}
		let item_index = undefined;
		this.state.payment.item.map((_item, _item_i) => {
			if (
				_item.product_id === item.product_id
				&& parseFloat(_item.price) === parseFloat(item.price)
				&& parseFloat(_item.ratio) === parseFloat(item.ratio)
				&& parseFloat(_item.discount) === parseFloat(item.discount)
				&& _item.discount_type === item.discount_type
			) {
				item_index = _item_i;
			}
			return false;
		})
		if (item_index !== undefined) {
			_payment.item[item_index]._quantity += item._quantity;
			_payment.item[item_index].quantity = parseFloat(_payment.item[item_index]._quantity) * parseFloat(_payment.item[item_index].ratio);
		} else {
			_payment.item.push({
				...item,
				_quantity: item._quantity,
				quantity: item._quantity * parseFloat(item.ratio)
			})
		}
		console.log(item_index);
		this.setState({
			payment: _payment
		}, () => {
			if (this.props.split_mode && !this.props.current_bill_payment) {
				this.runEffect(item_index);
			}
		})
	}

	decreaseItem(item) {
		let _payment = {...this.state.payment}
		let item_index = undefined;
		this.state.payment.item.map((_item, _item_i) => {
			if (
				_item.product_id === item.product_id
				&& parseFloat(_item.price) === parseFloat(item.price)
				&& parseFloat(_item.ratio) === parseFloat(item.ratio)
				&& parseFloat(_item.discount) === parseFloat(item.discount)
				&& _item.discount_type === item.discount_type
			) {
				item_index = _item_i;
			}
			return false;
		})
		if (item_index !== undefined) {
			_payment.item[item_index]._quantity -= item._quantity;
			_payment.item[item_index].quantity = parseFloat(_payment.item[item_index]._quantity) * parseFloat(_payment.item[item_index].ratio);
		}
		this.setState({
			payment: _payment
		})
	}

	notSpecifiedSerialNumber(number) {
		let not_specified_serial_number = [];
		for (let i = 0; i < number; i++) {
			not_specified_serial_number.push(
				<div key={i} style={{marginTop: 5}}>
					ยังไม่ได้ระบุ Serial Number
				</div>
			)
		}
		return not_specified_serial_number;
	}

	ManageItemModal(item, item_i) {
		window.Global.reactToDom(
			window.$('#POS_viewRoot'),
			<ManageItem
				payment={this.props.payment}
				payment_item={item}
				onEdit={(_item) => {
					let payment = {...this.props.payment};
					if (_item._quantity === 0) {
						payment.item.splice(item_i, 1);
					} else {
						payment.item[item_i] = _item;
					}
					this.props.updatePayment(payment);
				}}
			/>
		);
	}

	suggestPromotion(payment, options) {
		if (this.promotionBtn) {
			this.promotionBtn.addClass('loading');
		}
		if (!payment) {
			return false;
		}
		let data = {};
		data.for_relationship_id = payment.relationship ? payment.relationship.id : '';
		data.focus_user_position_item = '';
		data.is_change_relationship = 1;
		data.item = [];
		payment.item.forEach((item) => {
			let _item = {};
			_item.product = item.product;
			_item.product_id = item.product_id;
			_item._quantity = item._quantity;
			_item.quantity = item.quantity;
			_item.ratio = item.ratio;
			_item.price = item.price;
			_item.discount = item.discount;
			_item.discount_type = item.discount_type;
			_item.tax = item.tax;
			_item.tax_type = item.tax_type;
			data.item.push(_item);
		});
		window.Global.ajax({
			method: 'POST',
			url: process.env.REACT_APP_DOMAIN + '/api/sale_order/suggestPromotion',
			data: data,
			done: (responseJson) => {
				payment.item.forEach((item, item_index) => {
					payment.item[item_index]._quantity = responseJson.item[item_index]._quantity;
					payment.item[item_index].quantity = responseJson.item[item_index].quantity;
					payment.item[item_index].ratio = responseJson.item[item_index].ratio;
					payment.item[item_index].price = responseJson.item[item_index].price;
					payment.item[item_index].discount = responseJson.item[item_index].discount;
					payment.item[item_index].discount_type = responseJson.item[item_index].discount_type;
					payment.item[item_index].tax = responseJson.item[item_index].tax;
					payment.item[item_index].tax_type = responseJson.item[item_index].tax_type;
					payment.item[item_index].product = responseJson.item[item_index].product;
				});
				this.setState({
					payment: payment,
				}, () => {
					if (options && options.onDone) {
						options.onDone(this.state.payment);
					}
					if (this.promotionBtn) {
						this.promotionBtn.removeClass('loading')
					}
				})
			}
		})
	}

	render() {
		let serial_number_empty = this.state.payment.item.filter((item) => {
			let count_product_serial_num = item.product_serial_number.length;
			return item.product.is_serial_number && count_product_serial_num !== item._quantity;
		});
		let summary = window.GlobalFunc.calculateSummary(this.$parent,
			this.props.payment,
			((this.props.payment.item ? this.props.payment.item : []).filter(() => {
				return true;
			}))
		);
		return (
			<>
				<div className="ui secondary segment"
				     ref={(ref) => {
					     this.$parent = window.$(ref)
				     }}
				     style={{paddingLeft: 0, fontSize: allpage_fontSize, paddingTop: '1rem', paddingBottom: '1rem'}}>
					<div className={"flex row middle-xs"}>
						{
							!this.props.split_mode ?
								<div className={"col-lg-2 center-xs"}>
									<i className="trash alternate icon"
									   style={{
										   cursor: 'pointer',
										   lineHeight: 1,
										   color: this.props.payment.item.length === 0 ? '#ccc' : null
									   }}
									   onClick={() => {
										   if (this.props.payment.item.length === 0) {
											   return false;
										   }
										   Helper.posConfirmModal({
											   title: 'ต้องการลบรายการสินค้าทั้งหมดหรือไม่ ?',
											   content: 'โปรดยืนยันลบข้อมูล',
											   cancel_text: 'ไม่ดำเนินการ',
											   approve_text: 'ลบรายการสินค้าทั้งหมด',
											   onApprove: () => {
												   let payment = {...this.state.payment};
												   if (this.props.split_mode) {
													   this.state.payment.item.map((item, item_i) => {
														   payment.item[item_i]._quantity = 0;
														   payment.item[item_i].quantity = parseFloat(payment.item[item_i]._quantity) * parseFloat(payment.item[item_i].ratio);
														   return false;
													   })
												   }
												   if (!this.props.split_mode) {
													   payment.item = [];
												   }
												   this.setState({
													   payment: payment,
												   }, () => {
													   this.props.updatePayment(payment);
												   })
											   },
										   });
									   }}
									/>
								</div>
								: null
						}
						<div className={!this.props.split_mode ? "col-lg-7" : "col-lg-9"}>
							<strong>สินค้า</strong></div>
						<div className={"col-lg-4 center-xs flex"}>
							<strong>จำนวน</strong></div>
						<div className={"col-lg-3"}>
							<div style={{textAlign: 'right'}}>
								<strong>ราคา</strong>
							</div>
						</div>
					</div>
				</div>
				<div className="ui segment item-segment payment-segment"
				     ref={(ref) => {
					     this.$paymentSegment = window.$(ref)
				     }}
				>
					{
						this.props.payment.item
						&& this.props.payment.item.length > 0 ?
							this.props.payment.item.map((item, item_i) => {
								let calculate_item_price = Helper.CalculateItemPrice(item, {
									tax_type: this.props.payment.tax_type,
								})
								let discount_per_quantity = (parseFloat(calculate_item_price.total_net_price / item._quantity)).round(2);
								if (isNaN(discount_per_quantity) || discount_per_quantity <= 0) {
									discount_per_quantity = 0;
								}
								if (item._quantity === 0) {
									return null
								}

								// console.log(item);

								return (
									<div className={"flex row item-list"}
									     key={item_i}
									     style={{
										     padding: !this.props.split_mode ? '1em 1em 1em 0' : '1.8rem',
										     fontSize: allpage_fontSize
									     }}
									     onClick={this.props.current_bill_payment ? () => {
											     let payment = {...this.props.payment};
											     payment.item[item_i]._quantity = parseFloat(this.props.payment.item[item_i]._quantity) - 1;
											     if (payment.item[item_i].discount_type === '฿') {
												     payment.item[item_i].price = discount_per_quantity
												     payment.item[item_i].discount = 0;
											     }
											     this.props.updatePaymentItem(payment.item[item_i]);
											     if (parseFloat(this.props.payment.item[item_i]._quantity) <= 0) {
												     let payment = {...this.props.payment};
												     payment.item[item_i]._quantity = 0;
											     }


											     payment.item[item_i].quantity = parseFloat(payment.item[item_i]._quantity) * parseFloat(payment.item[item_i].ratio);
											     this.setState({
												     payment: payment,
											     })

										     }
										     : null
									     }
									>
										{
											!this.props.split_mode ?
												<div className={"col-lg-2 flex middle-xs center-xs"}>
													<i className="trash alternate icon"
													   style={{cursor: 'pointer'}}
													   onClick={() => {
														   let payment = {...this.props.payment};
														   if (this.props.split_mode) {
															   payment.item[item_i]._quantity = 0;
														   }
														   if (!this.props.split_mode) {
															   payment.item.splice(item_i, 1);
														   }
														   this.props.updatePayment(payment);
													   }}
													/>
												</div>
												: null
										}
										<div
											className={!this.props.split_mode ? "col-lg-7 flex row middle-xs" : "col-lg-9 flex row middle-xs"}>
											<div style={{flex: 1}}>
												<div onClick={() => {
													if (this.props.split_mode) {
														return false
													}
													this.ManageItemModal(item, item_i);
												}}>
													{
														item.product ?
															<div style={{
																cursor: 'pointer',
																fontWeight: 'bold',
																fontSize: '1.5rem'
															}}>
																{item.product.name}
															</div>
															: null
													}
													<div style={{marginTop: 5}}>
													   <span style={{
														   color: calculate_item_price.discount === 0 ? '#02B04E' : null,
														   textDecoration: calculate_item_price.discount > 0 ? 'line-through' : null
													   }}>
										                     ฿{parseFloat(item.price).format(2)} / {Helper.getRatioUnit(item.product, item.ratio).unit_name}
										                </span>
													</div>
													{
														calculate_item_price.discount > 0 ?
															<div style={{marginTop: 5}}>
															   <span style={{color: '#02B04E'}}>
														            ฿{discount_per_quantity} / {Helper.getRatioUnit(item.product, item.ratio).unit_name}
															   </span>
																<label className={"ui label red small"}
																       id={"item-label"}>
																	ลด {
																	calculate_item_price.discount_type === '฿' ?
																		calculate_item_price.discount_type
																		: null
																}
																	{
																		calculate_item_price.discount
																	}
																	{
																		calculate_item_price.discount_type === '%' ?
																			calculate_item_price.discount_type
																			: null
																	}
																</label>
															</div>
															: null
													}
													{
														item.description ?
															<div style={{marginTop: 5}}>
																{item.description}
															</div>
															: null
													}
												</div>
												{

													item._product_serial_number.length > 0 ?
														item._product_serial_number.map((product_serial_number, product_serial_number_index) => {
															return (
																<div className={"flex row"}
																     key={product_serial_number_index}
																     style={{marginTop: 5, lineHeight: 1.3}}
																>
																	{
																		!this.props.split_mode ?
																			<i className="trash alternate icon"
																			   onClick={() => {
																				   let payment = {...this.props.payment};
																				   // let payment_serial_number_index = payment.serial_number.findIndex((product_serial_number_id) => {
																				   //    return product_serial_number_id === product_serial_number.id;
																				   // });

																				   payment.serial_number = payment.serial_number.filter((product_serial_number_id) => {
																					   return product_serial_number_id !== product_serial_number.id;
																				   })

																				   payment.item[item_i].product_serial_number = payment.item[item_i].product_serial_number.filter((product_serial_number_id) => {
																					   return product_serial_number_id !== product_serial_number.id;
																				   })

																				   payment.item[item_i]._product_serial_number = payment.item[item_i]._product_serial_number.filter((__product_serial_number) => {
																					   return __product_serial_number.id !== product_serial_number.id;
																				   })
																				   // return;

																				   // payment.serial_number.splice(payment_serial_number_index, 1);
																				   // payment.item[item_i].product_serial_number.splice(product_serial_number_index, 1);
																				   // payment.item[item_i]._product_serial_number.splice(product_serial_number_index, 1);

																				   this.props.updatePayment(payment);
																			   }}
																			   style={{cursor: 'pointer'}}
																			/>
																			: null
																	}
																	<span>{product_serial_number.serial_number}</span>
																</div>
															);
														})
														: null
												}
												{
													item.product.is_serial_number
													&& parseFloat(item._quantity) > item.product_serial_number.length ?
														<div onClick={() => {
															window.Global.reactToDom(
																window.$('body'),
																<PaymentsSerialNumberSelector
																	payment={item}
																	onSuccess={(product_serial_number) => {
																		let _payment = {...this.props.payment};
																		let count_product_serial_number = _payment.serial_number.filter((product_serial_number_id) => {
																			return product_serial_number_id === product_serial_number.id;
																		}).length;
																		if (count_product_serial_number > 1) {
																			return false;
																		}
																		if (item.product_serial_number.length > parseFloat(item._quantity)) {
																			return false;
																		}
																		// เก็บข้อมูล id
																		_payment.serial_number.push(product_serial_number.id);
																		_payment.item[item_i].product_serial_number.push(product_serial_number.id);
																		// เก็บข้อมูล Product Serial Number
																		_payment.item[item_i]._product_serial_number.push(product_serial_number);
																		this.props.updatePayment(_payment);
																	}}
																/>
															)
														}}
														     className={"link"}
														>
															{this.notSpecifiedSerialNumber(parseFloat(item._quantity) - item.product_serial_number.length)}
														</div>
														: null
												}
											</div>
										</div>
										<div
											className={!this.props.split_mode ? "col-lg-4" : "col-lg-4 center-xs flex"}>
											<div className={"flex row middle-xs"} id={"item_quantity"}
											     style={{marginTop: !this.props.split_mode ? '0.8rem' : 0}}>
												{
													!this.props.current_bill_payment ?
														<button className={"payment_item_button"}
														        onClick={() => {
															        let payment = {...this.props.payment};
															        payment.item[item_i]._quantity = parseFloat(this.props.payment.item[item_i]._quantity) - 1;
															        if (payment.item[item_i]._quantity < this.props.payment.item[item_i].product_serial_number.length
																        && !this.props.split_mode) {
																        this.props.payment.item[item_i].product_serial_number.forEach((product_serial_number, product_serial_number_index) => {
																	        if (product_serial_number_index >= payment.item[item_i]._quantity) {
																		        payment.serial_number = payment.serial_number.filter((serial_number) => {
																			        return serial_number !== product_serial_number
																		        });
																	        }
																        });
																        payment.item[item_i].product_serial_number = this.props.payment.item[item_i].product_serial_number.filter((_product_serial_number, product_serial_number_index) => {
																	        return product_serial_number_index < payment.item[item_i]._quantity;
																        }) || [];
																        payment.item[item_i]._product_serial_number = this.props.payment.item[item_i]._product_serial_number.filter((_product_serial_number, product_serial_number_index) => {
																	        return product_serial_number_index < payment.item[item_i]._quantity;
																        });
															        }
															        if (parseFloat(this.props.payment.item[item_i]._quantity) <= 0
																        && !this.props.split_mode
															        ) {
																        payment.item[item_i]._quantity = 0;
																        Helper.posConfirmModal({
																	        title: 'ต้องการลบรายการสินค้าหรือไม่ ?',
																	        content: 'โปรดยืนยันการลบรายการสินค้า',
																	        cancel_text: 'ไม่ดำเนินการ',
																	        approve_text: 'ลบรายการสินค้า',
																	        onApprove: () => {
																		        let payment = {...this.props.payment};
																		        payment.item.splice(item_i, 1);
																		        this.props.updatePayment(payment);
																	        },
																	        onClose: () => {
																		        payment.item[item_i]._quantity = 1;
																		        payment.item[item_i].quantity = payment.item[item_i]._quantity * payment.item[item_i].ratio;
																		        this.props.updatePayment(payment);
																	        }
																        });
																        return false;
															        }
															        if (this.props.deCreaseItem) {
																        this.props.deCreaseItem(item)
															        }
															        if (this.props.split_mode && payment.item[item_i]._quantity <= 0) {
																        payment.item[item_i]._quantity = 0;
															        }
															        payment.item[item_i].quantity = parseFloat(payment.item[item_i]._quantity) * parseFloat(payment.item[item_i].ratio);
															        if (this.props.split_mode) {
																        if (payment.item[item_i]._quantity === 0) {
																	        payment.item.splice(item_i, 1);
																        }
																        this.setState({
																	        payment: payment
																        })
															        }
															        if (!this.props.split_mode) {
																        this.props.updatePayment(payment);
															        }
														        }}
														>
															<i className={"icon minus"}
															   style={{margin: 0}}/>
														</button>
														: null
												}

												<div onClick={() => {
													if (this.props.split_mode) {
														return false;
													}
													this.ManageItemModal(item, item_i);
												}} style={{
													flex: 1,
													textAlign: 'center',
													fontWeight: 'bold',
													fontSize: '1.5rem'
												}}>
													{item._quantity}
												</div>

												{
													!this.props.current_bill_payment ?
														<button className={"payment_item_button"}

														        onClick={() => {
															        let payment = {...this.props.payment};
															        payment.item[item_i]._quantity = parseFloat(this.props.payment.item[item_i]._quantity) + 1;
															        if (payment.item[item_i]._quantity <= payment.item[item_i].max_quantity
																        && this.props.inCreaseItem) {
																        this.props.inCreaseItem(item)
															        }
															        if (this.props.split_mode && payment.item[item_i]._quantity >= payment.item[item_i].max_quantity) {
																        payment.item[item_i]._quantity = payment.item[item_i].max_quantity;
															        }
															        payment.item[item_i].quantity = parseFloat(payment.item[item_i]._quantity) * parseFloat(payment.item[item_i].ratio);
															        if (this.props.split_mode) {
																        this.setState({
																	        payment: payment
																        })
															        }
															        if (!this.props.split_mode) {
																        this.props.updatePayment(payment);
															        }
														        }}
														>
															<i className={"icon plus"}
															   style={{margin: 0}}/>
														</button>
														: null
												}
											</div>
										</div>
										<div className={!this.props.split_mode ? "col-lg-3" : "col-lg-3 flex"}
										     style={{
											     textAlign: 'right',
											     marginTop: !this.props.split_mode ? '1.6rem' : 0,
											     fontWeight: 'bold',
											     justifyContent: this.props.split_mode ? 'center' : null
										     }}>
											฿{item._quantity <= 0 ? (0).format(2) : calculate_item_price.total_price.format(2)}
										</div>
									</div>
								)
							})
							: null
					}
					{!this.props.payment.item
					|| (this.props.payment.item
						&& this.props.payment.item.length === 0) ?
						<div style={{
							padding: '2rem',
							fontSize: allpage_fontSize,
							textAlign: 'center'
						}}>ไม่มีรายการสินค้า</div>
						: null
					}
				</div>
				{
					this.props.payment ?
						<>
							<div className={"ui segment select-segment"}
							     style={{fontSize: allpage_fontSize}}
							     onClick={() => {
								     window.Global.reactToDom(window.$('body'),
									     <POSRelationShipSelector
										     payment={this.props.payment}
										     onSuccess={(_payment) => {
											     if (!this.props.split_mode) {
												     this.suggestPromotion(_payment, {
													     onDone: (__payment) => {
														     this.props.onUpdateRelationship(__payment)
													     }
												     });
											     }
											     if (this.props.split_mode) {
												     this.setState({
													     payment: cloneDeep(_payment)
												     }, () => {
													     this.props.onUpdateRelationship(this.state.payment)
												     })
											     }
										     }}
									     />
								     )
							     }}
							>
								<div className={"flex row"}>
									<strong>{this.props.payment.relationship ? this.props.payment.relationship.name : ''}</strong>
									<div className={"right floated"}>
										<i className={"icon edit"} style={{margin: 0}}/>
									</div>
								</div>
							</div>
							<div className={"ui segment"} style={{fontSize: allpage_fontSize}}>
								<div className={"flex row"}>
									<strong>
										รวมทั้งสิ้น
										{
											!this.props.split_mode
											&& this.props.payment.item.length > 0 ?
												<span className={"pos-link link"}
												      onClick={() => {
													      if (serial_number_empty.length > 0) {
														      Helper.messageTopPOS({
															      type: 'negative',
															      message: 'กรุณาระบุ SerialNumber'
														      });
														      this.PaymentBtn.removeClass('loading');
														      return;
													      }
													      this.props.splitBillPayment()
												      }}
												>
										   แยกจ่าย
										   </span>
												: null
										}
									</strong>
									<strong className={"right floated"}>
										฿{summary.total_net_price2}
									</strong>
								</div>
							</div>
							<div className={"ui segment"}
							     id={"payment-action"}
							     style={{height: this.props.current_bill_payment ? 146 : null}}>
								{
									!this.props.current_bill_payment ?
										<div className={"flex row"}>
											{
												!this.props.split_mode ?
													<button className={"ui button icon massive blue custom-submit-btn"}
													        style={{
														        padding: button_padding,
														        fontSize: button_fontSize,
														        marginRight: '1rem'
													        }}
													        ref={(ref) => this.promotionBtn = window.$(ref)}
													        onClick={() => {
														        if (!this.props.payment || this.promotionBtn.hasClass('loading')) {
															        return false
														        }
														        this.suggestPromotion(this.props.payment);
													        }}
													>
														<i className={"icon heart"}
														   style={{fontSize: '4rem', lineHeight: 0.8}}/>
													</button>
													: null
											}
											{
												this.props.split_mode ?
													<button className={"ui button icon massive custom-submit-btn"}
													        style={{
														        padding: button_padding,
														        fontSize: button_fontSize,
														        width: '15rem',
														        marginRight: '1.8rem'
													        }}
													        ref={(ref) => this.promotionBtn = window.$(ref)}
													        onClick={() => {
														        this.props.onClose()
													        }}
													>
														ยกเลิก
													</button>
													: null
											}
											<button className={"ui button massive icon fluid green custom-submit-btn"}
											        style={{
												        padding: button_padding,
												        fontSize: button_fontSize,
												        marginRight: 0
											        }}
											        ref={(ref) => this.PaymentBtn = window.$(ref)}
											        onClick={() => {
												        if (this.PaymentBtn.hasClass('loading')) {
													        return;
												        }
												        this.PaymentBtn.addClass('loading');
												        let payment = {...this.props.payment};

												        if (serial_number_empty.length > 0) {
													        Helper.messageTopPOS({
														        type: 'negative',
														        message: 'กรุณาระบุ SerialNumber'
													        });
													        this.PaymentBtn.removeClass('loading');
													        return;
												        }
												        if (summary.total_net_price === 0) {
													        Helper.messageTopPOS({
														        type: 'negative',
														        message: 'ไม่มีรายการสินค้า'
													        });
													        this.PaymentBtn.removeClass('loading');
													        return;
												        }
												        let _payment = {...payment};
												        _payment.payment = Helper.defaultPOSPayment(payment, payment.item, window.user.id, this.props.pos);
												        window.Global.reactToDom(
													        window.$('#POS_viewRoot'),
													        <PaymentModal
														        payment={{..._payment}}
														        login_user={{...window.user}}
														        pos={{...this.props.pos}}
														        onHide={() => {
															        this.PaymentBtn.removeClass('loading');
														        }}
														        onSuccess={(responseJson) => {
															        this.props.onSuccessPayment(responseJson);
															        this.PaymentBtn.removeClass('loading');
														        }}
													        />
												        );
											        }}
											>
												ชำระเงิน {summary.total_net_price.format(2)} บาท
											</button>
										</div>
										: null
								}

							</div>
						</>
						: null
				}
			</>
		);
	}
}

class POSTSelector extends React.Component {
	constructor() {
		super();
		this.state = {
			search_query: '',
			pos: [],
			is_loading: true,
		}
	}

	componentDidMount() {
		this.fetchPOS();
	}

	fetchPOS() {
		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/pos',
			data: {
				search_query: this.state.search_query,
				from_device: 'mobile'
			},
			done: (response) => {
				this.setState({
					pos: response.pos,
					is_loading: false,
				})
			}
		})
	}

	render() {
		this.modal = null;
		return (
			<div className={"custom-modal center-xs"}
			     ref={(ref) => {
				     this.$modal = window.$(ref)
			     }}
			     style={{backgroundColor: '#f4f4f4'}}
			>
				<div className={"ui segment"} style={{width: '60%'}}>
					<div className="header">
						<h1 style={{marginTop: 0, marginBottom: 0}}>
							เลือกเครื่อง POS
						</h1>
					</div>
					<div className="content">
						{
							this.state.is_loading ?
								<div className="ui active centered inline loader"/>
								: null
						}
						{
							!this.state.is_loading ?
								<div className={"ui list"}>
									{
										this.state.pos.map((pos, pos_i) => {
											return (
												<div className="item" key={pos_i}
												     style={{marginTop: pos_i > 0 ? '1rem' : 0, marginBottom: 0}}>
													<div className="ui segment segment-selector"
													     onClick={() => {
														     this.props.onSuccess(pos);
														     this.$modal.remove();
													     }}
													>
														<h2 className="header">{pos.name}</h2>
													</div>
												</div>
											);
										})
									}
								</div>
								: null
						}
					</div>
				</div>
			</div>
		);
	}
}

class PaymentsSerialNumberSelector extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			product_serial_number: [],
			is_loading: true,
			search_query: '',
		}
	}

	componentDidMount() {
		this.fetch();
	}

	fetch() {
		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/product_serial_number',
			data: {
				product_id: this.props.payment.product.id,
				product_serial_number: true,
				stock_in_stock_id: 1,
				serial_number_is_set: 1,
				from_device: 'mobile',
				search_query: this.state.search_query,
			},
			done: (response) => {
				// console.log(response);;
				let product_serial_number = [...response.product_serial_number];
				this.setState({
					product_serial_number: product_serial_number,
					is_loading: false,
				})
			}
		})
	}

	render() {
		let count = 0;
		let match = 0;
		this.state.product_serial_number.map((product_serial_number, product_serial_number_i) => {
			count++;
			this.props.payment._product_serial_number.map((_product_serial_number) => {
				if (_product_serial_number.id === product_serial_number.id) {
					match++;
				}
				return null;
			})
			return null;
		});
		return (
			<div className={"custom-modal center-xs"}
			     ref={(ref) => {
				     this.$manage_serial_number = window.$(ref)
			     }}
			>
				<div className={"overlay"}
				     onClick={() => {
					     this.$manage_serial_number.remove()
				     }}
				/>
				<div className="ui segment" style={{width: '60%'}}>

					<div className="content">
						<form className={"ui form manage-item-custom"}>
							<div className={"flex row"}>
								<input type="text"
								       ref={(ref) => {
									       this.input = window.$(ref);
								       }}
								       name={"search_query"}
								       placeholder="ค้นหาลูกค้า"
								       value={this.state.search_query}
								       style={{flex: 1}}
								       onChange={(e) => {
									       let search_query = e.target.value;
									       this.setState({
										       is_loading: true,
										       search_query: search_query,
									       }, () => {
										       // console.log(this.state.search_query);
										       this.fetch();
									       })
								       }}
								/>
								<button className={"ui button massive close"}
								        style={{
									        marginLeft: '1rem',
								        }}
								        onClick={() => {
									        this.$manage_serial_number.remove()
								        }}
								>
									ปิด
								</button>
							</div>
						</form>
						<div className={"ui list"} style={{height: 795, overflowY: 'auto'}}>
							{
								!this.state.is_loading
								&& (match !== count)
								&& this.state.product_serial_number.length > 0 ?
									this.state.product_serial_number.map((product_serial_number, product_serial_number_i) => {
										let match = 0;
										this.props.payment._product_serial_number.map((_product_serial_number) => {
											if (_product_serial_number.id === product_serial_number.id) {
												match++;
											}
											return null;
										})
										if (match > 0) {
											return null;
										}
										return (
											<div className="item"
											     key={product_serial_number_i}
											>
												<div
													className={this.state.block_btn ? "ui segment secondary segment-selector" : "ui segment segment-selector"}
													ref={(ref) => {
														this['serialNo' + product_serial_number_i] = window.$(ref);
													}}
													onClick={() => {
														if (this.state.block_btn) {
															return null
														}
														this['serialNo' + product_serial_number_i].addClass('loading');
														this.setState({
															block_btn: true
														}, () => {
															this.props.onSuccess(product_serial_number);
															this.$manage_serial_number.remove();
														})
													}}
												>
													<div style={{
														fontSize: allpage_fontSize,
														textAlign: 'left'
													}}
													     className="header">{product_serial_number.serial_number}</div>
												</div>
											</div>
										);
									})
									: null
							}

							{
								this.state.is_loading ?
									<div className="ui active centered inline loader"/>
									: null
							}
							{
								!this.state.is_loading
								&& (this.state.product_serial_number.length === 0
									|| (match === count)
								) ?
									<div style={{marginTop: '2rem', textAlign: 'center', fontSize: '2rem'}}>ไม่มีเลข
										Serial Number</div>
									: null
							}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

class POSRelationShipSelector extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			relationship: [],
			is_loading: true,
			search_query: '',
		}
	}

	componentDidMount() {
		this.fetch();
		this.input.select();
	}

	fetch() {
		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/relationship',
			data: {
				search_query: this.state.search_query,
				is_customer: 1,
				limit: 10,
				from_device: 'mobile',
			},
			done: (response) => {
				// console.log(response);;
				let relationship = [...response.relationship];
				this.setState({
					relationship: relationship,
					is_loading: false,
				})
			}
		})
	}

	render() {
		return (
			<div className={"custom-modal center-xs"}
			     ref={(ref) => {
				     this.$manage_relationship = window.$(ref)
			     }}
			>
				<div className={"overlay"}
				     onClick={() => {
					     this.$manage_relationship.remove()
				     }}
				/>
				<div className="ui segment" style={{width: '60%'}}>
					<div className="content">
						<form className={"ui form manage-item-custom"}>
							<div className={"flex row"}>
								<input type="text"
								       ref={(ref) => {
									       this.input = window.$(ref);
								       }}
								       name={"search_query"}
								       placeholder="ค้นหาลูกค้า"
								       value={this.state.search_query}
								       style={{flex: 1}}
								       onChange={(e) => {
									       let search_query = e.target.value;
									       this.setState({
										       is_loading: true,
										       search_query: search_query,
									       }, () => {
										       this.fetch();
									       })
								       }}
								/>
								<button className={"ui button massive close"}
								        style={{
									        marginLeft: '1rem',
								        }}
								        onClick={() => {
									        this.$manage_relationship.remove()
								        }}
								>
									ปิด
								</button>
							</div>
						</form>

						<div className={"ui list"} style={{height: 795, overflowY: 'auto'}}>
							{
								this.state.is_loading ?
									<div className="ui active centered inline loader"/>
									: null
							}
							{
								!this.state.is_loading
								&& this.state.relationship.length > 0 ?
									this.state.relationship.map((relationship, relationship_i) => {
										return (
											<div className="item"
											     key={relationship_i}
											>
												<div
													className={this.state.block_btn ? "ui segment secondary segment-selector" : "ui segment segment-selector"}
													ref={(ref) => {
														this['Relationship' + relationship_i] = window.$(ref);
													}}
													onClick={() => {
														if (this.state.block_btn) {
															return null
														}
														this['Relationship' + relationship_i].addClass('loading');
														this.setState({
															block_btn: true
														}, () => {
															let payment = {...this.props.payment};
															if (relationship.relationship_branch
																&& relationship.relationship_branch.length > 0
															) {
																payment.relationship_branch = relationship.relationship_branch[0];
																payment.relationship_branch_id = relationship.relationship_branch[0].id;
															}
															payment.relationship = relationship;
															payment.relationship_id = relationship.id;
															this.props.onSuccess(payment);
															this.$manage_relationship.remove();
														})
													}}
												>
													<div className={"flex row"}>
														<div style={{
															fontSize: allpage_fontSize,
															textAlign: 'left'
														}}
														     className="header">
															{relationship.name}
															{
																relationship.code ?
																	<div style={{
																		fontSize: allpage_fontSize,
																		color: '#999'
																	}}
																	>
																		{relationship.code}
																	</div>
																	: null
															}
														</div>
														<div className={"right floated flex row middle-xs"}>
															{
																relationship.phone.length > 0 ?
																	<>
																		<i className={"icon phone"}/>
																		{
																			relationship.phone.map((phone, phone_i) => {
																				return (
																					<div style={{
																						fontSize: allpage_fontSize,
																						color: '#000',
																						textAlign: 'right'
																					}} key={phone_i}>
																						{
																							phone_i > 0 ? ", " : null
																						}
																						{phone}
																					</div>
																				)
																			})
																		}
																	</>
																	: null
															}
															<i className={"arrow right icon"}
															   style={{
																   color: '#ccc',
																   fontSize: 25,
																   marginLeft: 25
															   }}/>
														</div>
													</div>
												</div>
											</div>
										);
									}) : null
							}
							{
								!this.state.is_loading
								&& this.state.relationship.length === 0 ?
									<div style={{
										marginTop: '2rem',
										textAlign: 'center',
										fontSize: '2rem'
									}}>ไม่มีข้อมูล</div>
									: null
							}
						</div>

					</div>
				</div>
			</div>
		);
	}
}

class ManageItemPrice extends React.Component {
	render() {
		return (
			<div className={"custom-modal with-bg manage-item manage-item-big"}
			     ref={(ref) => {
				     this.$modal = window.$(ref)
			     }}
			>
				<div className="ui segment flex"
				     style={{width: '100%', height: '100%'}}
				>
					<div className={"flex"} style={{flex: 1, justifyContent: 'center'}}>
						<div className="header flex row" style={{marginBottom: '2.5rem'}}>
							<h1 className={"header-large"}>{this.props.title}</h1>
						</div>
						<div className="content ui form manage-item-custom"
						     style={{fontSize: allpage_fontSize}}>
							<input name={"total_price"}
							       type={"text"}
							       defaultValue={this.props.total_price || 0}
							       ref={(ref) => {
								       this.$total_price = window.$(ref);
								       callCalculator(ref);
								       window.$(ref).off('change keyup').on('change keyup', (e) => {
									       let amount = e.target.value;
									       amount = Helper.setAmount(amount);
									       window.$(ref).val(amount);
								       });
							       }}
							/>
						</div>
					</div>
					<div className="actions" style={{marginTop: 40}}>
						<div className={"flex row"}>
							<button className="ui button basic fluid custom-submit-btn"
							        style={{
								        cursor: 'pointer',
								        width: '30%',
							        }}
							        ref={(ref) => {
								        this.$close = window.$(ref)
							        }}
							        type={"button"}
							        onClick={() => {
								        if (this.$close.hasClass('loading')) {
									        return false;
								        }
								        this.$close.addClass('loading');
								        if (this.props.onClose) {
									        this.props.onClose();
								        }
								        this.$modal.remove();
							        }}
							>
								ยกเลิก
							</button>
							<button className="ui approve button green fluid custom-submit-btn"
							        style={{
								        cursor: 'pointer'
							        }}
							        ref={(ref) => {
								        this.$approve = window.$(ref)
							        }}
							        type={"submit"}
							        onClick={() => {
								        if (this.$approve.hasClass('loading')) {
									        return false;
								        }
								        this.$approve.addClass('loading');
								        if (this.props.onApprove) {
									        let price = this.$total_price.val().round(2);
									        this.props.onApprove(price);
								        }
								        this.$modal.remove()
							        }}
							>
								ยืนยันคำนวณราคาต่อหน่วยตามราคานี้
							</button>
						</div>

					</div>

				</div>
			</div>
		);
	}
}

class ManageItem extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			payment_item: props.payment_item,
		}
	}

	componentDidMount() {
		let times = setTimeout(() => {
			this.$manage_item.find('.segment').removeClass('loading');
			clearTimeout(times);
		}, 300)
	}

	render() {
		// console.log(Helper.getRatioUnit(this.state.payment_item.product, this.state.payment_item.ratio));
		let calculate_item_price = Helper.CalculateItemPrice(this.state.payment_item, {
			tax_type: this.props.payment.tax_type,
		})
		// console.log(calculate_item_price);
		return (
			<div className={"custom-modal with-bg manage-item"}
			     ref={(ref) => {
				     this.$manage_item = window.$(ref)
			     }}
			>
				<div className="ui segment flex loading"
				     style={{width: '100%', height: '100%'}}
				>
					{
						this.state.payment_item ?
							<>
								<div className={"flex"} style={{flex: 1}}>
									<div className="header flex row" style={{marginBottom: '2.5rem'}}>
										<h1 style={{fontSize: 55}}>{this.state.payment_item.product.name}</h1>
										<div className={"right floated  flex center-xs"}>
											<div
												onClick={() => {
													window.Global.reactToDom(window.$('#POS_viewRoot'),
														<ManageItemPrice
															title={"ระบุยอดราคารวม"}
															total_price={calculate_item_price.total_net_price}
															onApprove={(total_price) => {
																let text = parseFloat(total_price) / this.state.payment_item._quantity;
																let payment_item = {...this.state.payment_item};
																if (isNaN(text) || !text) {
																	text = '0';
																}
																payment_item.discount = 0;
																payment_item.price = text.round(2);
																this.setState({
																	payment_item: payment_item,
																}, () => {
																	this.$price.val(this.state.payment_item.price);
																	this.$discount.val(this.state.payment_item.discount)
																});
															}}
														/>
													);
												}}
												style={{fontSize: 25, color: '#02b04e', cursor: 'pointer'}}>
												ทั้งหมด
												฿{calculate_item_price.total_net_price.format(2)}
											</div>
										</div>
									</div>
									<div className="content ui form manage-item-custom"
									     style={{fontSize: allpage_fontSize}}>
										<div className={"flex row padded custom-row center-xs"}>
											<div className="column col-xs-4 padded">
												<div className="ui right labeled input small" style={{width: '100%'}}>
													<button className="ui basic label"
													        style={{
														        cursor: 'pointer',
													        }}
													        onClick={() => {
														        let payment_item = {...this.state.payment_item};
														        payment_item._quantity = this.state.payment_item._quantity - 1;
														        payment_item.quantity = payment_item._quantity * payment_item.ratio;
														        if (this.state.payment_item._quantity <= 0) {
															        payment_item._quantity = 0;
															        payment_item.quantity = 0;
														        }
														        this.$quantity.val(payment_item._quantity);
														        this.setState({
															        payment_item: payment_item,
														        });
													        }}

													>
														<i className={"icon minus"}
														   style={{margin: 0, fontSize: button_fontSize}}/>
													</button>
													<input type="text"
													       placeholder="จำนวน"
													       id="_quantity"
													       style={{
														       flex: 1,
														       width: '100%',
														       textAlign: 'center',
													       }}
													       ref={(ref) => {
														       this.$quantity = window.$(ref);
														       callCalculator(ref);
														       window.$(ref).off('change keyup').on('change keyup', (e) => {
															       let text = e.target.value;
															       let payment_item = {...this.state.payment_item};
															       text = Helper.setAmount(text);
															       payment_item._quantity = text;
															       payment_item.quantity = payment_item._quantity.round(2) * payment_item.ratio;

															       if (payment_item._quantity <= 0) {
																       payment_item._quantity = 0;
																       payment_item.quantity = 0;
															       }
															       this.setState({
																       payment_item: payment_item,
															       });
														       });
													       }}
													       defaultValue={this.state.payment_item._quantity || 0}
													/>
													<button className="ui basic label"
													        style={{
														        cursor: 'pointer',
													        }}
													        onClick={() => {
														        let payment_item = {...this.state.payment_item};
														        payment_item._quantity = this.state.payment_item._quantity + 1;
														        payment_item.quantity = payment_item._quantity * payment_item.ratio;
														        this.$quantity.val(payment_item._quantity);
														        this.setState({
															        payment_item: payment_item,
														        });
													        }}
													>
														<i className={"icon plus"}
														   style={{margin: 0, fontSize: button_fontSize}}/>
													</button>
												</div>
											</div>
											<div className={"column col-xs-4 padded"}>
												<button className={"ui button basic fluid"}
												        onClick={() => {
													        window.Global.reactToDom(window.$('body'),
														        <SellPriceSelector
															        payment_item={this.state.payment_item}
															        onSelected={(obj) => {
																        let payment_item = {...this.state.payment_item};
																        payment_item.ratio = obj.default_item_sell.ratio;
																        payment_item.quantity = payment_item._quantity * obj.default_item_sell.ratio;
																        this.$price.val(obj.default_item_sell.price);
																        this.$discount.val(obj.default_item_sell.discount);
																        payment_item.price = obj.default_item_sell.price;
																        payment_item.discount = obj.default_item_sell.discount;
																        // payment_item.discount = obj.default_item_sell.discount;
																        this.setState({
																	        payment_item: payment_item,
																        })
															        }}
														        />
													        );
												        }}

												>
													{Helper.getRatioUnit(this.state.payment_item.product, this.state.payment_item.ratio).unit_name}
												</button>
											</div>
										</div>
										<div className={"flex row padded custom-row center-xs"}>
											<div className={"column col-xs-6 padded"}>
												<div className="ui right labeled input" style={{width: '100%'}}>
													<input type={"text"}
													       style={{textAlign: 'center', flex: 1}}
													       defaultValue={this.state.payment_item.price + ''}
													       ref={(ref) => {
														       this.$price = window.$(ref);
														       callCalculator(ref);
														       window.$(ref).off('change keyup').on('change keyup', (e) => {
															       let text = e.target.value;
															       let payment_item = {...this.state.payment_item};
															       text = Helper.setAmount(text);
															       payment_item.discount = 0;
															       payment_item.price = text;
															       this.setState({
																       payment_item: payment_item,
															       }, () => {
																       this.$discount.val(this.state.payment_item.discount)
															       });
														       });
													       }}
													/>
													<div className="ui basic label"
													     style={{
														     display: "flex",
														     alignItems: "center",
														     fontWeight: 100
													     }}
													>
														บาท
													</div>
												</div>

											</div>
											<div className={"column col-xs-6 padded"}>
												<div className={"flex row"}>
													<div className="ui left labeled input"
													     style={{flex: 1, marginRight: '1rem'}}
													>
														<label className={"ui label basic"}
														       style={{
															       display: "flex",
															       alignItems: 'center',
															       marginBottom: 0
														       }}
														>
															ส่วนลด
														</label>
														<input type="text"
														       style={{
															       padding: 15,
															       textAlign: 'center',
															       flex: 1
														       }}
														       placeholder="ราคาส่วนลด"
														       ref={(ref) => {
															       this.$discount = window.$(ref);
															       callCalculator(ref);
															       window.$(ref).off('change keyup').on('change keyup', (e) => {
																       let text = e.target.value;
																       let payment_item = {...this.state.payment_item};
																       text = Helper.setAmount(text);
																       if (text > 100 && this.state.payment_item.discount_type === '%') {
																	       text = 0;
																	       this.$discount.val(0)
																       }

																       payment_item.discount = text;
																       this.setState({
																	       payment_item: payment_item,
																       }, () => {
																	       this.$discount.val(this.state.payment_item.discount)
																       });
															       });
														       }}
														       defaultValue={this.state.payment_item.discount + ''}
														/>
													</div>
													<div className={"right floated custom-button-border"}>
														<button
															className={this.state.payment_item.discount_type === "฿" ? "ui button basic green massive" : "ui button basic massive"}
															style={{marginRight: '1rem'}}
															onClick={() => {
																let obj = "฿";
																let payment_item = {...this.state.payment_item};
																payment_item.discount_type = obj;
																payment_item.discount = 0;
																this.$discount.val(0);
																this.setState({
																	payment_item: payment_item,
																})
															}}
														>฿
														</button>
														<button
															className={this.state.payment_item.discount_type === "%" ? "ui button basic green massive" : "ui button basic massive"}
															style={{marginRight: 0}}
															onClick={() => {
																let obj = "%";
																let payment_item = {...this.state.payment_item};
																payment_item.discount_type = obj
																payment_item.discount = 0;
																this.$discount.val(0);
																this.setState({
																	payment_item: payment_item,
																})
															}}
														>%
														</button>
													</div>
												</div>
											</div>
										</div>
									</div>
									{
										Helper.getRatioUnit(this.state.payment_item.product, this.state.payment_item.ratio)
										&& Helper.getRatioUnit(this.state.payment_item.product, this.state.payment_item.ratio).product_price_conditions
										&& Helper.getRatioUnit(this.state.payment_item.product, this.state.payment_item.ratio).product_price_conditions.length > 0 ?
											<Slider
												ref={(ref) => this.slider = ref}
												dots={5}
												infinite={false}
												speed={500}
												slidesToShow={4}
												slidesToScroll={1}
												style={{marginLeft: -5, marginRight: -5}}
												arrows={false}
												className={"custom-manage-item"}
											>

												{
													Helper.getRatioUnit(this.state.payment_item.product, this.state.payment_item.ratio).product_price_conditions.map((product_price_condition, product_price_conditions_index) => {
														return (
															<div key={product_price_conditions_index}
															     style={{height: '100%'}}>
																<div style={{
																	paddingLeft: 5,
																	paddingRight: 5,
																	height: '100%'
																}}>
																	<div
																		className={this.state.payment_item.price === product_price_condition.price
																		&& this.state.payment_item.discount === product_price_condition.discount
																		&& this.state.payment_item.discount_type === product_price_condition.discount_type ?
																			"active product_price_condition_box" : "product_price_condition_box"}
																		style={{
																			padding: button_padding,
																			fontSize: button_fontSize,
																			cursor: 'pointer',
																			height: '100%',
																			display: "flex",
																			flexDirection: 'column',
																		}}
																		onClick={() => {
																			let payment_item = {...this.state.payment_item};
																			this.$price.val(product_price_condition.price || 0);
																			this.$discount.val(product_price_condition.discount || 0);
																			// this.$discount_type.dropdown('set selected', product_price_condition.discount_type || '฿')
																			payment_item.price = product_price_condition.price;
																			payment_item.discount = product_price_condition.discount;
																			payment_item.discount_type = product_price_condition.discount_type;
																			this.setState({
																				payment_item: payment_item,
																			})
																		}}
																	>
																		<div className={" fluid flex row"}
																		     style={{width: '100%'}}>
																			<div style={{color: '#000'}}>
																				<div
																					style={{textAlign: 'left'}}>{product_price_condition.name}</div>
																				{
																					product_price_condition.product_price_condition_stair_step ?
																						<div>{">= " + product_price_condition.product_price_condition_stair_step.text1}</div>
																						: null
																				}
																				{
																					product_price_condition.product_price_condition_stair_step ?
																						<div>{"<= " + product_price_condition.product_price_condition_stair_step.text2}</div>
																						: null
																				}
																			</div>
																			<div className="right floated">
																				<div
																					style={{color: '#02B04E'}}>
																					฿{product_price_condition.price.format(2, 3, {pretty: false})}
																				</div>
																				{
																					// ไม่มีลดราคา ต่อ 1 ตัวนะครับ (10 ตัวก็ลดราคาเท่านี้)
																					product_price_condition.discount ?
																						<div style={{color: '#D85356'}}>
																							ลด {product_price_condition.discount.format(2, 3, {pretty: false}) + product_price_condition.discount_type}
																						</div>
																						: null
																				}
																			</div>
																		</div>
																		{
																			product_price_condition.description ?
																				<div style={{width: '100%'}}>
																					{product_price_condition.description}
																				</div>
																				: null
																		}
																	</div>
																</div>
															</div>
														);
													})
												}
											</Slider>
											: null
									}
									<div className="content ui form manage-item-custom"
									     style={{fontSize: allpage_fontSize}}>
										<div className={"flex row padded custom-row center-xs"}
										     style={{marginTop: '2rem'}}>
											<div className="column col-xs-12 padded">
												<input type={"text"}
												       name={"description"}
												       value={this.state.payment_item.description || ''}
												       placeholder={"รายละเอียดเพิ่มเติม"}
												       onChange={(e) => {
													       let text = e.target.value;
													       let payment_item = {...this.state.payment_item};
													       payment_item.description = text;
													       this.setState({
														       payment_item: payment_item
													       })
												       }}
												/>
											</div>
										</div>
									</div>
								</div>
								<div className="actions" style={{marginTop: 40}}>
									<div className={"flex row"}>
										<button className="ui button basic fluid custom-submit-btn"
										        style={{
											        cursor: 'pointer',
											        width: '30%',
										        }}
										        type={"button"}
										        onClick={() => {
											        this.$manage_item.remove()
										        }}
										>ยกเลิก
										</button>
										{
											parseFloat(this.state.payment_item.quantity) <= 0 ?
												<button className="ui approve button red fluid custom-submit-btn"
												        style={{
													        cursor: 'pointer'
												        }}
												        type={"submit"}
												        onClick={() => {
													        this.props.onEdit(this.state.payment_item);
													        this.$manage_item.remove();
												        }}
												>ยกเลิกรายการ</button>
												:
												<button className="ui approve button green fluid custom-submit-btn"
												        style={{
													        cursor: 'pointer'
												        }}
												        type={"submit"}
												        onClick={() => {
													        let payment_item = {...this.state.payment_item};
													        payment_item.price = this.state.payment_item.price.round(2);
													        payment_item.discount = this.state.payment_item.discount.round(2);
													        this.props.onEdit(payment_item);
													        this.$manage_item.remove();
													        closeCalculator();
												        }}
												>ตกลง</button>
										}
									</div>

								</div>
							</>
							: null
					}
				</div>
			</div>
		);
	}
}

class SellPriceSelector extends React.Component {


	render() {
		return (
			<div className={"custom-modal center-xs"}
			     ref={(ref) => {
				     this.modal = window.$(ref)
			     }}
			>
				<div className={"overlay"}
				     onClick={() => {
					     this.modal.remove()
				     }}
				/>
				<div className={"ui segment"}
				     style={{width: '40%'}}
				>
					<div className={"header"}>
						<h1 className={"ui header"}>
							เลือกหน่วยนับ
						</h1>
					</div>
					<div className="content">
						{
							this.props.payment_item.product.sell_price
							&& this.props.payment_item.product.sell_price.length > 0 ?
								<div className={"ui list"}>
									{this.props.payment_item.product.sell_price.map((sell_price, sell_price_i) => {
										return (
											<div className="item"
											     key={sell_price_i}
											>
												<div
													style={{
														textAlign: 'left',
														padding: button_padding,
														fontSize: (allpage_fontSize),
														cursor: 'pointer'
													}}
													className={sell_price.ratio === this.props.payment_item.ratio ? "ui segment secondary segment-selector  flex row" : "ui segment segment-selector flex row"}
													ref={(ref) => {
														this['serialNo' + sell_price_i] = window.$(ref);
													}}
													onClick={() => {
														this['serialNo' + sell_price_i].addClass('loading');
														this.props.onSelected(sell_price);
														this.modal.remove();
													}}
												>
													<div
														className="header">{sell_price.unit_name}</div>
													<div className={"right floated"}>
														{
															sell_price.ratio === this.props.payment_item.ratio ?
																<i className="check icon"
																   style={{color: 'green'}}/>
																: null
														}
													</div>
												</div>
											</div>
										)
									})}
								</div>

								: null
						}
					</div>
				</div>
			</div>
		);
	}
}

class PaymentModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			discount_type: '฿',
			discount_type_list: ['%', 'บาท'],
			payment_by: 'cash',
			payment: props.payment || false,
			isLoadingScreen: true,
			isLoadingBtn: false,
			keyboardDidShow: false,
			hours: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
			minutes: ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59"],
		};
	}

	render() {
		let summary = window.GlobalFunc.calculateSummary(this.$parent,
			this.state.payment,
			((this.state.payment.item ? this.state.payment.item : []).filter(() => {
				return true;
			}))
		);
		return (
			<div className={"custom-modal with-bg payment-modal"} ref={(ref) => this.$modal_payment = window.$(ref)}>
				<div className={"ui segment"} style={{width: '100%', height: '100%'}}>
					<div className={"flex row padded"}>
						<div className={"col-lg-10 column padded"}>
							<div className={"flex row payment-button"} style={{marginBottom: '2rem'}}>
								<button
									className={this.state.payment_by === 'cash' ? "active" : ""}
									onClick={() => {
										this.setState({payment_by: 'cash'})
									}}
								>
									เงินสด
								</button>
								<button
									className={this.state.payment_by === 'bank_transfer' ? "active" : ""}
									onClick={() => {
										let payment = {...this.state.payment};
										let count_payment_by_bank_transfer = this.state.payment.payment.filter((payment) => {
											return payment.payment_by === 'bank_transfer'
										}).length;

										if (count_payment_by_bank_transfer === 0) {

											let default_price = 0;
											this.state.payment.payment.map((_payment, _payment_i) => {
												if (_payment.payment_by === 'cash') {
													if (parseFloat(_payment.price) === summary.total_net_price
														&& parseFloat(_payment.payment_by_cash_pos.receive_amount) === 0
													) {
														payment.payment[_payment_i].price = 0;
														default_price = summary.total_net_price;
													}
												}
												return null;
											});

											payment.payment.push({
												payment_by: "bank_transfer",
												price: default_price,
												paid_on: window.moment().format('YYYY-MM-DD HH:mm'),
												bank_to_id: false,
												bank_from_code: '',
												bank_reference_code: '',
												charge: 0,
												charge_type: '%',
												charge_price: 0,
											});
										}
										this.setState({
											payment_by: 'bank_transfer',
											payment: payment,
										});
									}}
								>
									โอนเงิน
								</button>
							</div>

							<div>
								{
									this.state.payment.payment.map((payment, payment_i) => {
										if (payment.payment_by !== this.state.payment_by) {
											return null;
										}
										return <PaymentBy
											key={payment_i}
											index={payment_i}
											selectExplorer={(data) => {
												this.props.selectExplorer(data);
											}}
											pos_id={this.state.payment.pos_id}
											onCloseSecondModal={this.props.onCloseSecondModal}
											payment={payment}
											total={parseFloat(summary.total_net_price)}
											onUpdate={(response) => {
												let _payment = {...this.state.payment};
												_payment.payment[payment_i] = response;
												this.setState({
													payment: _payment,
												}, () => {
													window.localStorage.setItem('payment', JSON.stringify(_payment));
												})
											}}
										/>;
									})
								}
							</div>
						</div>
						<div className={"col-lg-6 column padded payment-summary"}>
							<div className={"flex"} style={{height: '100%'}}>
								<div className="flex" style={{flex: 1}}>
									<div className={"flex row middle-xs payment-summary-details-row"}>
										<div><strong>รวมทั้งสิ้น</strong></div>
										<div className={"right floated"}>
											{summary.total_price_before_discount.format(2, 3, {pretty: false})} บาท
										</div>
									</div>
									<div className={"flex row middle-xs wrap payment-summary-details-row"}>
										<div style={{flexShrink: 1}}><strong>ส่วนลดรวม</strong></div>
										<div className={"right floated "}>
											<div className="ui action input" style={{justifyContent: 'flex-end'}}>
												<input type="text"
												       placeholder="ราคาส่วนลด"
												       style={{flex: 'none', width: '50%'}}
												       defaultValue={this.state.payment.discount + ''}
												       ref={(ref) => {
													       this.$discount = window.$(ref);
													       callCalculator(ref);
													       window.$(ref).off('change keyup').on('change keyup', (e) => {

														       let amount = e.target.value;
														       let payment = {...this.state.payment};
														       // console.log(payment);
														       amount = amount.replace(/,/g, '');
														       if (isNaN(amount) || amount === '' || parseFloat(amount) < 0) {
															       amount = 0;
														       }
														       if (payment.discount_type === '฿' && amount > summary.total_price_before_discount) {
															       amount = summary.total_price_before_discount;
														       }
														       if (payment.discount_type === '%' && amount > 100) {
															       amount = 100;
														       }
														       let count = (amount.match(/\./g) || []).length;
														       if (count === 2) {
															       amount = amount.replace('..', '.');
														       }
														       if (count === 0) {
															       amount = parseFloat(amount);
														       }
														       payment.discount = amount;
														       payment.payment.map((payment_by, payment_by_i) => {
															       if (payment_by.payment_by === this.state.payment_by) {
																       payment.payment[payment_by_i].price = window.GlobalFunc.calculateSummary(this.$parent,
																	       payment,
																	       ((payment.item ? payment.item : []).filter(() => {
																		       return true;
																	       }))
																       ).total_net_price;
															       }
															       return false
														       })
														       // payment.payment = Helper.defaultPOSPayment(payment, this.state.payment.item, this.props.login_user.id, this.props.pos);
														       window.$(ref).val(payment.discount);
														       this.setState({
															       payment_by: this.state.payment_by,
															       payment: payment,
														       }, () => {
															       window.localStorage.setItem('payment', JSON.stringify(payment));
														       });
													       });
												       }}
												/>
												<button className="ui button basic"
												        style={{fontSize: '2rem', padding: '1rem 2rem'}}
												        onClick={() => {
													        let discount_type = '฿';
													        if (this.state.discount_type === '฿') {
														        discount_type = '%';
													        }
													        let payment = {...this.state.payment};
													        if (discount_type === '%' && payment.discount > 100) {
														        payment.discount = 0;
													        }
													        payment.discount_type = discount_type;
													        // payment.payment = Helper.defaultPOSPayment(payment, this.state.payment.item, this.props.login_user.id, this.props.pos);
													        payment.payment.forEach((payment_by, payment_by_index) => {
														        if (payment_by.payment_by === 'cash') {
															        payment.payment[payment_by_index].payment_by_cash_pos.receive_amount = 0
														        }
														        if (payment_by.payment_by !== 'cash') {
															        payment.payment[payment_by_index].price = 0
														        }
													        })
													        payment.payment.map((payment_by, payment_by_i) => {
														        if (payment_by.payment_by === this.state.payment_by) {
															        payment.payment[payment_by_i].price = window.GlobalFunc.calculateSummary(this.$parent,
																        payment,
																        ((payment.item ? payment.item : []).filter(() => {
																	        return true;
																        }))
															        ).total_net_price;
														        }
														        return false
													        })
													        this.setState({
														        payment_by: this.state.payment_by,
														        payment: payment,
														        discount_type: discount_type
													        }, () => {
														        this.$discount.val(payment.discount)
														        window.localStorage.setItem('payment', JSON.stringify(payment));
													        })
												        }}
												>
													{this.state.discount_type}
												</button>
											</div>
										</div>
									</div>
									<div className={"flex row middle-xs payment-summary-details-row"}>
										<div><strong>รวมมูลค่าสินค้า</strong></div>
										<div className={"right floated"}>
											{summary.total_price.format(2, 3, {pretty: false})} บาท
										</div>
									</div>
									<div className={"flex row middle-xs payment-summary-details-row"}>
										<div>
											<strong>ภาษีมูลค่าเพิ่ม {summary.tax}%</strong>
										</div>
										<div className={"right floated"}>
											{summary.total_tax_price.format(2, 3, {pretty: false})} บาท
										</div>
									</div>
									<div className={"flex row middle-xs payment-summary-details-row"}>
										<div><strong>ราคาไม่รวมภาษีมูลค่าเพิ่ม</strong></div>
										<div className={"right floated"}>
											{summary.total_price_exclude_vat.format(2, 3, {pretty: false})} บาท
										</div>
									</div>
									<div className={"flex row middle-xs payment-summary-details-row"}>
										<div><strong>จำนวนเงินรวมทั้งสิ้น</strong></div>
										<div className={"right floated"}>
											{summary.total_net_price_without_withholding_tax.format(2, 3, {pretty: false})} บาท
										</div>
									</div>
									<div className={"flex row middle-xs payment-summary-details-row"}>
										<div><strong>ยอดชำระ</strong></div>
										<div className={"right floated"}>
											{summary.total_net_price.format(2, 3, {pretty: false})} บาท
										</div>
									</div>
									{
										this.state.payment.payment.length > 0 ?
											<div className={"ui divider"}/>
											: null
									}
									{
										this.state.payment.payment.map((payment_by, payment_by_key) => {
											if (payment_by.payment_by === 'cash'
												&& payment_by.price > 0
											) {
												return (
													<div key={payment_by_key}>
														<div
															className={"flex row middle-xs payment-summary-details-row"}>
															<div><strong>เงินสด</strong></div>
															<div className={"right floated"}>
																{payment_by.price.format(2, 3, {pretty: false})} บาท
															</div>
														</div>
														<div
															className={"flex row middle-xs payment-summary-details-row"}>
															<div><strong>รับเงิน</strong></div>
															<div className={"right floated"} style={{color: '#02B04E'}}>
																{payment_by.payment_by_cash_pos.receive_amount.format(2, 3, {pretty: false})} บาท
															</div>
														</div>
														<div
															className={"flex row middle-xs payment-summary-details-row"}>
															<div><strong>เงินทอน</strong></div>
															<div className={"right floated"} style={{color: '#D85356'}}>
																{payment_by.payment_by_cash_pos.change_amount.format(2, 3, {pretty: false})} บาท
															</div>
														</div>
													</div>
												);
											}
											if (payment_by.payment_by === 'bank_transfer'
												&& parseFloat(payment_by.price) > 0
											) {
												return (
													<div className={"flex row middle-xs payment-summary-details-row"}
													     key={payment_by_key}>
														<div><strong>โอนเงิน</strong></div>
														<div className={"right floated"}>
															{payment_by.price.format(2, 3, {pretty: false})} บาท
														</div>
													</div>
												);
											}
											return null;
										})
									}
									<div className={"ui divider"}/>
								</div>
								<div>
									<button className={"ui button red fluid custom-submit-btn"}
									        onClick={() => {
										        this.$modal_payment.remove();
										        this.props.onHide();
										        closeCalculator();
									        }}
									>
										ยกเลิก
									</button>
									<button className={"ui button green fluid custom-submit-btn"}
									        style={{marginTop: '2rem'}}
									        ref={(ref) => {
										        this.$success_payment_button = window.$(ref);
									        }}
									        onClick={() => {
										        if (this.$success_payment_button.hasClass('loading')) {
											        return false;
										        }
										        this.$success_payment_button.addClass('loading');
										        let clone_payment = window.Object.assign({}, {...this.state.payment});

										        delete clone_payment.relationship;
										        delete clone_payment.relationship_branch;
										        delete clone_payment.stock;
										        delete clone_payment.title;

										        let payments = [];
										        clone_payment.payment.map((payment) => {
											        if (payment.price > 0) {
												        payments.push(payment);
											        }
											        return null;
										        });
										        clone_payment.payment = payments;

										        let items = [];
										        clone_payment.item.map((item) => {
											        let item2 = Object.assign({}, item);
											        delete item2.product;
											        delete item2._product_serial_number;
											        items.push(item2);
											        return null;
										        });
										        clone_payment.item = items;
										        if (!this.props.print_mode || (this.props.print_mode && this.props.print_mode === "Offline")) {
											        clone_payment.disable_create_print_queue = 1;
										        }
										        clone_payment.from_device = 'mobile';
										        // if (this.state.payment_by === 'bank_transfer') {
										        //     console.log(this.modal_payment.find('*[name="paid_on"]'));
										        //     if (this.modal_payment.find('*[name="paid_on"]')) {
										        //         console.log(this.modal_payment.find('*[name="paid_on"]').val());
										        //     }
										        //
										        //     return;
										        // }
										        // clone_payment.doc_date = window.moment().format('YYYY-MM-DD');
										        // console.log(clone_payment);
										        // return;
										        window.Global.ajax({
											        url: process.env.REACT_APP_DOMAIN + '/api/sale_order/payment',
											        method: 'POST',
											        data: clone_payment,
											        done: (responseJson) => {
												        if (responseJson.error) {
													        Helper.messageTopPOS({
														        type: 'negative',
														        message: responseJson.message[0].error_message
													        })
													        this.$success_payment_button.removeClass('loading');
													        //return;
												        }
												        if (responseJson.success) {
													        this.props.onSuccess(responseJson);
													        this.$modal_payment.remove();
													        window.localStorage.setItem('payment', '');
													        closeCalculator();
												        }
											        },
											        fail: () => {
												        this.$success_payment_button.removeClass('loading');
											        }
										        })

									        }}
									>ชำระเงิน
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

class PaymentBy extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			_date: new Date(),
			text_price: props.payment.payment_by_cash_pos ? props.payment.payment_by_cash_pos.receive_amount : 0,
			payment: props.payment,
			isDateTimePicker: false,
			isTimePicker: false,
			time: false,
			hours: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
			minutes: ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59"],
			hour: window.moment().format('HH'),
			minute: window.moment().format('mm'),
			banks: [],
		}
	}

	componentDidUpdate(prevProps) {
		if (this.props.payment.price !== prevProps.payment.price) {
			console.log("change Price");
			this.setState({
				text_price: this.props.payment.payment_by_cash_pos ? this.props.payment.payment_by_cash_pos.receive_amount : 0,
				payment: this.props.payment,
			}, () => {
				if (this.$total_price_input) {
					this.$total_price_input.val(this.state.payment.price);
				}
			});
		}
		if (this.$total_price_input) {
			this.$total_price_input.val(this.props.payment.price);
		}
		if (this.$receive_input) {
			this.$receive_input.val(this.props.payment
				&& this.props.payment.payment_by_cash_pos
				&& this.props.payment.payment_by_cash_pos.receive_amount !== undefined
					?
					this.props.payment.payment_by_cash_pos.receive_amount
					: 0
			);
		}
	}

	componentDidMount() {
		if (window.localStorage.getItem('bank_default_pos_' + this.props.pos_id) && window.localStorage.getItem('bank_default_pos_' + this.props.pos_id) !== '') {
			let value = JSON.parse(window.localStorage.getItem('bank_default_pos_' + this.props.pos_id));
			window.Global.ajax({
				url: process.env.REACT_APP_DOMAIN + '/api/bank',
				method: 'GET',
				data: {
					page: 1,
					method: 'pay_in',
					payment_by: 'bank_transfer',
					from_device: 'mobile',
					bank_id: value.bank_id
				},
				done: (response) => {
					if (response.bank.length > 0) {
						// console.log("SET VALUE");
						window.$('input[name="bank_to_id"]')
						window.$('input[name="bank_to_id"]').explorer('set value', response.bank[0]);
					}
				}
			})
		}
	}

	fetchBank() {
		window.Global.ajax({
			url: process.env.REACT_APP_DOMAIN + '/api/bank',
			method: 'GET',
			data: {
				page: 1,
				method: 'pay_in',
				payment_by: 'bank_transfer',
				from_device: 'mobile',
			},
			done: (response) => {
				this.setState({
					banks: response.bank,
				})
			}
		})
	}

	clearReceiveMoney() {
		let payment = {...this.state.payment};
		payment.payment_by_cash_pos.receive_amount = 0;
		payment.payment_by_cash_pos.change_amount = 0;
		payment.payment_by_cash_pos.banknote_1000 = 0;
		payment.payment_by_cash_pos.banknote_500 = 0;
		payment.payment_by_cash_pos.banknote_100 = 0;
		payment.payment_by_cash_pos.banknote_50 = 0;
		payment.payment_by_cash_pos.banknote_20 = 0;
		payment.payment_by_cash_pos.coin_10 = 0;
		payment.payment_by_cash_pos.coin_5 = 0;
		payment.payment_by_cash_pos.coin_2 = 0;
		payment.payment_by_cash_pos.coin_1 = 0;
		payment.payment_by_cash_pos.coin_0_5 = 0;
		payment.payment_by_cash_pos.coin_0_25 = 0;
		this.setState({
			text_price: payment.payment_by_cash_pos.receive_amount,
			payment: payment
		}, () => {
			this.props.onUpdate(this.state.payment);
		})
	}

	onReceiveMoney(amount, is_not_banknote) {
		let payment = {...this.state.payment};
		if (is_not_banknote) {
			payment.payment_by_cash_pos.receive_amount = amount;
			if (parseFloat(amount) === 0) {
				this.clearReceiveMoney();
			}
		}
		if (!is_not_banknote) {
			payment.payment_by_cash_pos.receive_amount = parseFloat(this.state.payment.payment_by_cash_pos.receive_amount) + parseFloat(amount);
			if (parseFloat(amount) === 1000) {
				payment.payment_by_cash_pos.banknote_1000 = (this.state.payment.payment_by_cash_pos.banknote_1000 || 0) + 1
			}
			if (parseFloat(amount) === 500) {
				payment.payment_by_cash_pos.banknote_500 = (this.state.payment.payment_by_cash_pos.banknote_500 || 0) + 1
			}
			if (parseFloat(amount) === 100) {
				payment.payment_by_cash_pos.banknote_100 = (this.state.payment.payment_by_cash_pos.banknote_100 || 0) + 1
			}
			if (parseFloat(amount) === 50) {
				payment.payment_by_cash_pos.banknote_50 = (this.state.payment.payment_by_cash_pos.banknote_50 || 0) + 1
			}
			if (parseFloat(amount) === 20) {
				payment.payment_by_cash_pos.banknote_20 = (this.state.payment.payment_by_cash_pos.banknote_20 || 0) + 1
			}
			if (parseFloat(amount) === 10) {
				payment.payment_by_cash_pos.coin_10 = (this.state.payment.payment_by_cash_pos.coin_10 || 0) + 1
			}
			if (parseFloat(amount) === 5) {
				payment.payment_by_cash_pos.coin_5 = (this.state.payment.payment_by_cash_pos.coin_5 || 0) + 1
			}
			if (parseFloat(amount) === 2) {
				payment.payment_by_cash_pos.coin_2 = (this.state.payment.payment_by_cash_pos.coin_2 || 0) + 1
			}
			if (parseFloat(amount) === 1) {
				payment.payment_by_cash_pos.coin_1 = (this.state.payment.payment_by_cash_pos.coin_1 || 0) + 1
			}
			if (parseFloat(amount) === 0.5) {
				payment.payment_by_cash_pos.coin_0_5 = (this.state.payment.payment_by_cash_pos.coin_0_5 || 0) + 1
			}
			if (parseFloat(amount) === 0.25) {
				payment.payment_by_cash_pos.coin_0_25 = (this.state.payment.payment_by_cash_pos.coin_0_25 || 0) + 1
			}
		}

		payment.payment_by_cash_pos.change_amount = this.getchangeAmount(payment);

		this.setState({
			text_price: payment.payment_by_cash_pos.receive_amount,
			payment: payment
		}, () => {
			this.props.onUpdate(this.state.payment);
		})
	}

	getchangeAmount(payment) {
		if (payment.price < payment.payment_by_cash_pos.receive_amount) {
			return payment.payment_by_cash_pos.receive_amount - payment.price;
		}
		return 0;
	}


	renderCash() {
		return (
			<div key={this.props.index} className={"payment-cash"}>
				<div className={"flex row button-relative "}>
					<button className={"ui button basic massive fluid item"}
					        style={{padding: button_padding, fontSize: button_fontSize, cursor: 'pointer'}}
					        onClick={() => {
						        this.onReceiveMoney(1000)
					        }}
					>
						1,000
						{
							this.state.payment.payment_by_cash_pos.banknote_1000
							&& this.state.payment.payment_by_cash_pos.banknote_1000 > 0 ?
								<span className="ui red label floating">
										   x{this.state.payment.payment_by_cash_pos.banknote_1000 || 0}
										   </span>
								: null
						}
					</button>
					<button className={"ui button basic massive fluid"}
					        style={{padding: button_padding, fontSize: button_fontSize, cursor: 'pointer'}}
					        onClick={() => {
						        this.onReceiveMoney(500)
					        }}
					>
						500
						{
							this.state.payment.payment_by_cash_pos.banknote_500
							&& this.state.payment.payment_by_cash_pos.banknote_500 > 0 ?
								<span className="ui red label floating">
										   x{this.state.payment.payment_by_cash_pos.banknote_500 || 0}
										   </span>
								: null
						}
					</button>
					<button className={"ui button basic massive fluid"}
					        style={{padding: button_padding, fontSize: button_fontSize, cursor: 'pointer'}}
					        onClick={() => {
						        this.onReceiveMoney(100)
					        }}
					>
						100
						{
							this.state.payment.payment_by_cash_pos.banknote_100
							&& this.state.payment.payment_by_cash_pos.banknote_100 > 0 ?
								<span className="ui red label floating">
										   x{this.state.payment.payment_by_cash_pos.banknote_100 || 0}
										   </span>
								: null
						}
					</button>
					<button className={"ui button basic massive fluid"}
					        style={{padding: button_padding, fontSize: button_fontSize, cursor: 'pointer'}}
					        onClick={() => {
						        this.onReceiveMoney(50)
					        }}
					>
						50
						{
							this.state.payment.payment_by_cash_pos.banknote_50
							&& this.state.payment.payment_by_cash_pos.banknote_50 > 0 ?
								<span className="ui red label floating">
										   x{this.state.payment.payment_by_cash_pos.banknote_50 || 0}
										   </span>
								: null
						}
					</button>
					<button className={"ui button basic massive fluid"}
					        style={{
						        padding: button_padding,
						        fontSize: button_fontSize,
						        cursor: 'pointer'
					        }}
					        onClick={() => {
						        this.onReceiveMoney(20)
					        }}
					>
						20
						{
							this.state.payment.payment_by_cash_pos.banknote_20
							&& this.state.payment.payment_by_cash_pos.banknote_20 > 0 ?
								<span className="ui red label floating">
										   x{this.state.payment.payment_by_cash_pos.banknote_20 || 0}
										   </span>
								: null
						}
					</button>
				</div>
				<div className={"flex row center-xs button-relative"} style={{marginTop: '1rem'}}>
					<button className={"ui button basic icon circular massive"}
					        style={{fontSize: button_fontSize, cursor: 'pointer'}}
					        onClick={() => {
						        this.onReceiveMoney(10)
					        }}
					>
						10
						{
							this.state.payment.payment_by_cash_pos.coin_10
							&& this.state.payment.payment_by_cash_pos.coin_10 > 0 ?
								<span className="ui red label floating">
										   x{this.state.payment.payment_by_cash_pos.coin_10 || 0}
										   </span>
								: null
						}
					</button>
					<button className={"ui button basic icon circular massive"}
					        style={{fontSize: button_fontSize, cursor: 'pointer'}}
					        onClick={() => {
						        this.onReceiveMoney(5)
					        }}
					>
						5
						{
							this.state.payment.payment_by_cash_pos.coin_5
							&& this.state.payment.payment_by_cash_pos.coin_5 > 0 ?
								<span className="ui red label floating">
										   x{this.state.payment.payment_by_cash_pos.coin_5 || 0}
										   </span>
								: null
						}
					</button>
					<button className={"ui button basic icon circular massive"}
					        style={{fontSize: button_fontSize, cursor: 'pointer'}}
					        onClick={() => {
						        this.onReceiveMoney(1)
					        }}
					>
						1
						{
							this.state.payment.payment_by_cash_pos.coin_1
							&& this.state.payment.payment_by_cash_pos.coin_1 > 0 ?
								<span className="ui red label floating">
										   x{this.state.payment.payment_by_cash_pos.coin_1 || 0}
										   </span>
								: null
						}
					</button>
					<button className={"ui button basic massive"}
					        style={{
						        padding: button_padding, fontSize: button_fontSize, cursor: 'pointer',
						        position: 'absolute',
						        right: 0,
					        }}
					        onClick={() => {
						        this.clearReceiveMoney();
					        }}
					>
						Clear
					</button>
				</div>

				<div className={"ui divider"} style={{marginTop: '2rem', marginBottom: '2rem'}}/>
				<div className={"flex row three column computer"}>
					<div className={"column"} style={{justifyContent: 'center', alignItems: 'center'}}>
						<h3 className={"ui header"} style={{textAlign: 'center'}}>
							<strong>ยอดที่ต้องชำระ</strong>
						</h3>
						<div style={{textAlign: 'center'}}>
							<input className={"pos-price-input"}
							       type={"text"}
							       defaultValue={this.state.payment.price ? this.state.payment.price.format(2) + '' : '0'}
							       ref={(ref) => {
								       this.$total_price_input = window.$(ref);
								       callCalculator(ref);
								       window.$(ref).off('change keyup').on('change keyup', (e) => {
									       let amount = e.target.value;
									       if (amount !== undefined) {
										       amount = Helper.setAmount(amount);
										       let payment = {...this.state.payment};

										       if (parseFloat(amount) >= this.props.total) {
											       amount = this.props.total;
										       }
										       payment.price = amount;
										       payment.payment_by_cash_pos.change_amount = this.getchangeAmount(payment);
										       this.setState({
											       payment: payment
										       }, () => {
											       this.props.onUpdate(this.state.payment);
										       })
									       }
								       });
							       }}
							/>
						</div>
					</div>
					<div className={"column"} style={{justifyContent: 'center', alignItems: 'center'}}>
						<h3 className={"ui header"} style={{textAlign: 'center'}}>
							<strong>รับเงิน</strong>
						</h3>
						<div style={{textAlign: 'center'}}>
							<input className={"pos-price-input"}
							       type={"text"}
							       ref={(ref) => {
								       this.$receive_input = window.$(ref);
								       callCalculator(ref);
								       window.$(ref).off('change keyup').on('change keyup', (e) => {
									       let text = e.target.value;
									       text = Helper.setAmount(text);
									       // text = parseFloat(text);
									       if (parseFloat(this.state.text_price) === text) {
										       return false;
									       }
									       if (isNaN(text)) {
										       text = 0
									       }
									       this.onReceiveMoney(text, true);
								       });
							       }}
							       style={{color: '#02B04E'}}
							       defaultValue={this.state.text_price ? this.state.text_price + '' : '0'}
							/>
						</div>
					</div>
					<div className={"column"} style={{justifyContent: 'center', alignItems: 'center'}}>
						<h3 className={"ui header"} style={{textAlign: 'center'}}>
							<strong>ทอน</strong>
						</h3>
						<div style={{textAlign: 'center'}}>
							<input className={"pos-price-input"}
							       style={{color: '#D85356'}}
							       readOnly={true}
							       value={this.state.payment.payment_by_cash_pos.change_amount ? this.state.payment.payment_by_cash_pos.change_amount.format(2) : '0'}
							/>
						</div>
					</div>
				</div>
			</div>
		);
	}

	renderBankTransfer() {
		return (
			<div className={"ui form big payment-banktransfer"}
			     ref={(ref) => {
				     window.$(ref).form2('setup');
			     }}
			     key={this.props.index}
			>
				<h3>โอนเข้าธนาคาร</h3>
				<div className="field explorer">
					<input name={"bank_to_id"}
					       ref={(ref) => {
						       let template = '<div class="item flex row middle-xs">\n    <div class="flex row middle-xs">\n        <div class={"bank_image_frame"} style="margin-right: 1rem">\n            <img src={{logo_url}} alt={"Bank"}/>\n        </div>\n        <div>\n            <div class={"back_name"}>\n                {{name}}\n            </div>\n            <div class={"back_description"}>\n                {{code_name}}\n                {{branch_name}}\n            </div>\n            <div class={"back_no"}>{{no}}</div>\n        </div>\n    </div>\n</div>';
						       window.$(ref).explorer({
							       url: process.env.REACT_APP_DOMAIN + '/api/bank',
							       additionalData: {
								       page: 1,
								       method: 'pay_in',
								       payment_by: 'bank_transfer',
								       from_device: 'mobile',
							       },
							       key: 'bank',
							       template: {
								       // language=HTML
								       list: template,
								       selected: {
									       display_template: template,
									       value: 'id',
									       placeholder: 'เลือกธนาคาร'
								       }
							       },
							       onSelected: (response) => {
								       let payment = {...this.state.payment};
								       payment.bank_to_id = response.id;
								       payment.bank_to = {
									       id: response.id,
									       name: response.name,
								       };
								       this.setState({
									       payment: payment,
								       }, () => {
									       this.props.onUpdate(this.state.payment);
									       window.localStorage.setItem('bank_default_pos_' + this.props.pos_id, JSON.stringify({bank_id: response.id}))
								       });
							       },
							       onUnSelected: () => {
								       let payment = {...this.state.payment};
								       payment.bank_to_id = false;
								       payment.bank_to = false;
								       this.setState({
									       payment: payment,
								       }, () => {
									       this.props.onUpdate(this.state.payment);
								       });
							       },
						       });

					       }}
					/>
				</div>
				<div className={"two fields"}>
					<div className="field">
						<label>วันที่ชำระเงิน</label>
						<DayPickerInput
							formatDate={(date) => {
								return window.moment(date).format('DD/MM')
									+ "/" + (parseInt(window.moment(date).format('YYYY')) + 543);
							}}
							onDayChange={(date) => {
								let payment = {...this.state.payment};
								let time = "00:00";
								if (this.state.hour) {
									time = this.state.hour + ':' + this.state.minute;
								}
								payment.paid_on = window.moment(date).format('YYYY-MM-DD') + ' ' + time;
								this.setState({
									_date: date,
									payment: payment,
								}, () => {
									this.props.onUpdate(this.state.payment);
								})
							}}
							// parseDate={parseDate}
							format="LL"
							locale={'th'}
							// placeholder={`${formatDate(new Date(), 'LL', 'th')}`}
							value={this.state._date}
							dayPickerProps={{
								locale: 'th',
								// localeUtils: MomentLocaleUtils,
							}}
						/>
						{/*<DatePicker*/}
						{/*	onChange={(date) => {*/}
						{/*		let payment = {...this.state.payment};*/}
						{/*		let time = "00:00";*/}
						{/*		if (this.state.hour) {*/}
						{/*			time = this.state.hour + ':' + this.state.minute;*/}
						{/*		}*/}
						{/*		payment.paid_on = window.moment(date).format('YYYY-MM-DD') + ' ' + time;*/}
						{/*		this.setState({*/}
						{/*			_date: date,*/}
						{/*			payment: payment,*/}
						{/*		}, () => {*/}
						{/*			this.props.onUpdate(this.state.payment);*/}
						{/*		})*/}
						{/*	}}*/}
						{/*	selected={this.state._date}*/}
						{/*	dateFormat="dd/MM/yyyy"*/}
						{/*/>*/}
					</div>
					<div className="field manage-item-custom">
						<label>เวลา</label>
						<div className="two fields center-input">
							<div className="field">
								<select className={"ui fluid selection dropdown"}
								        defaultValue={this.state.hour}
								        ref={(ref) => {
									        window.$(ref).dropdown({
										        'onChange': (hour) => {
											        let payment = {...this.state.payment};
											        let time = "00:00";
											        if (this.state.hour) {
												        time = hour + ':' + this.state.minute;
											        }
											        payment.paid_on = window.moment(this.state.payment.paid_on).format('YYYY-MM-DD') + ' ' + time;
											        this.setState({
												        payment: payment,
												        hour: hour
											        }, () => {
												        this.props.onUpdate(this.state.payment);
											        })
										        }
									        })
								        }}
								>
									{
										this.state.hours.map((hour, hour_i) => (
											<option value={hour} key={hour_i}>{hour}</option>
										))
									}
								</select>
							</div>
							<div className="field">
								<select className={"ui fluid selection dropdown"}
								        defaultValue={this.state.minute}
								        ref={(ref) => {
									        window.$(ref).dropdown({
										        'onChange': (minute) => {
											        let payment = {...this.state.payment};
											        let time = "00:00";
											        if (this.state.hour) {
												        time = this.state.hour + ':' + minute;
											        }
											        payment.paid_on = window.moment(this.state.payment.paid_on).format('YYYY-MM-DD') + ' ' + time;
											        this.setState({
												        payment: payment,
												        minute: minute
											        }, () => {
												        this.props.onUpdate(this.state.payment);
											        })
										        }
									        })
								        }}
								>
									{
										this.state.minutes.map((minute, minute_i) => (
											<option value={minute} key={minute_i}>{minute}</option>
										))
									}
								</select>

							</div>
						</div>
					</div>
				</div>
				<div className="field">
					<label>ยอดชำระเงิน</label>
					<input type={"text"}
					       ref={(ref) => {
						       this.$total_price_input = window.$(ref);
						       callCalculator(ref);
						       window.$(ref).off('change keyup').on('change keyup', (e) => {
							       let amount = e.target.value;
							       let payment = {...this.state.payment};
							       amount = Helper.setAmount(amount);
							       payment.price = amount;
							       this.setState({
								       payment: payment
							       }, () => {
								       this.props.onUpdate(this.state.payment);
							       })
						       });
					       }}
					       style={{fontSize: '3rem', textAlign: 'center'}}
					       defaultValue={parseFloat(this.state.payment.price) > 0 ? this.state.payment.price + '' : 0}
					       className={"payment_input_radius"}

					/>
				</div>
				<div className="field">
					<label>หมายเลขอ้างอิงการโอน</label>
					<input type={"text"}
					       value={this.state.payment.bank_reference_code + ''}
					       onChange={(e) => {
						       let text = e.target.value;
						       let payment = {...this.state.payment};
						       payment.bank_reference_code = text;
						       this.setState({
							       payment: payment
						       }, () => {
							       this.props.onUpdate(this.state.payment);
						       })
					       }}
					/>
				</div>
				<div className="flex row wrap"
				     ref={(ref) => {
					     if (!ref) return;
					     window.Global.ajax({
						     url: process.env.REACT_APP_DOMAIN + '/api/filter',
						     method: "GET",
						     data: {
							     type: 'payment_by_bank_transfer',
							     limit: 30,
						     },
						     done: (responseJson) => {
							     window.$(ref).empty();
							     window.$.each(responseJson['filter'], (i, filter) => {
								     if (this.state.payment
									     && this.state.payment.filter_payment_by_bank_transfer_id
									     && this.state.payment.filter_payment_by_bank_transfer_id.indexOf(filter.id) !== -1
								     ) {
									     filter.selected = 1;
								     }
								     let $e = window.$(window.Handlebars.compile('<button type="button"\n\t\tclass="ui button round {{#if selected}}green{{/if}} {{^if selected}}basic{{/if}} filter-button"\n\t\tstyle="font-size: 2rem;">\n\t{{name}}\n</button>')(filter));
								     window.$(ref).append($e);
								     $e.on('click', () => {
									     let payment = {...this.state.payment};
									     if (!payment.filter_payment_by_bank_transfer_id) {
										     payment.filter_payment_by_bank_transfer_id = [];
									     }

									     if (!$e.hasClass('green')) {
										     payment.filter_payment_by_bank_transfer_id.push(filter.id);
									     } else {
										     payment.filter_payment_by_bank_transfer_id.splice(
											     this.state.payment.filter_payment_by_bank_transfer_id.indexOf(filter.id),
											     1
										     );
									     }

									     this.setState({
										     payment: payment
									     }, () => {
										     this.props.onUpdate(this.state.payment);
										     console.log(this.state.payment);
									     })
								     })
							     })
						     }
					     })
				     }}>

				</div>
			</div>
		);
	}

	render() {
		if (this.props.payment.payment_by === 'cash') {
			return this.renderCash()
		}
		if (this.props.payment.payment_by === 'bank_transfer') {
			return this.renderBankTransfer()
		}
		return null
	}
}

export class PaymentModalDetails extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoadingBtn: false,
			count_down: false,
			on_printing: false,
			payment: props.payment
		}
	}

	componentDidMount() {
		if (this.props.run_printing) {
			this.printerQueue(this.state.payment);
			// this.$print_btn.trigger('click');
		}
	}

	printerQueue(payment) {
		this.setState({
			on_printing: true,
			print_message: "กำลังพิมพ์ใบเสร็จ",
		}, () => {
			Helper.printerQueue(payment, {
				onPrintFinish: (responseJson) => {
					this.setState({
						print_message: null,
						on_printing: false,
					})
				},
				onSuccess: (responseJson) => {
				},
				onError: (responseJson) => {

					Helper.messageTopPOS({
						type: 'negative',
						message: responseJson.message[0].error_message,
						delay: 5000
					});
					this.setState({
						print_message: 'พิมพ์ใบเสร็จอีกครั้ง'
					})
				}
			});
		})
	}

	render() {
		return (
			<div className={"custom-modal-fixed"}
			     ref={(ref) => {
				     this.$payment_history_details = window.$(ref);
				     this.$payment_history_details.form2('setup', {
					     is_auto_print_receipt_onChange: (is_auto_print_receipt) => {
						     localStorage.setItem(
							     'is_auto_print_receipt',
							     is_auto_print_receipt
						     )
					     }
				     });
			     }}
			>
				<div className="ui segment custom-history-modal"
				     style={{
					     width: '100%',
					     height: '100%',
					     display: 'flex',
					     flexDirection: 'column',
				     }}>
					<div className={"ui header dividing"}>
						<div className={" flex row middle-xs"}>
							<h2 className={"ui header"} style={{margin: 0}}>
								{this.state.payment.title} {this.state.payment.desc}
								<span
									className={"history_cancle"}
									style={{cursor: 'pointer', fontSize: '1.8rem', marginLeft: '1rem'}}
									onClick={() => {
										if (this.state.payment.is_deleted) {
											return false;
										}
										this.props.onSaleOrderCancle(this.state.payment,
											{
												onDone: (response) => {
													Helper.messageTopPOS({
														type: 'positive',
														message: 'ยกเลิกเรียบร้อย'
													});
													this.setState({
														payment: response.payment,
													});
												}
											})
									}}>
				{
					this.state.payment.is_deleted ?
						"ยกเลิกแล้ว"
						: "ยกเลิก"
				}

				</span>
							</h2>
							<div className={"right floated"}>
				<span
					ref={(ref) => {
						this.$print_btn = window.$(ref)
					}}
					className={this.state.on_printing ? "history_print printting" : "history_print"}
					onClick={() => {
						if (this.state.on_printing) {
							return
						}
						this.printerQueue(this.state.payment)
					}}
				>
				{this.state.print_message || "พิมพ์เอกสาร"}
				</span>
							</div>
						</div>
					</div>
					<div className={"flex row padded payment-details-row"}
					     style={{height: '100%', flexShrink: 1, overflow: 'hidden'}}>
						<div className="col-lg-10 padded flex column" style={{height: '100%'}}>
							<div className={"history_table_header row flex"}>
								<div className={"col-xs-10 padded"}>สินค้า</div>
								<div className={"col-xs-3 padded"}>จำนวน</div>
								<div className={"col-xs-3 padded"}>ราคา</div>
							</div>
							<div className={"history_table_body"}>
								{
									this.state.payment.payment_item.map((item, item_i) => {
										let discount_amount = item.price - (item.summary.discount_amount / (item.quantity / item.ratio));

										console.log(item.payment_item_serial_number);

										return (
											<div className="flex row middle-xs" key={item_i}>
												<div className={"col-xs-10 padded"} style={{paddingLeft: 0}}>
													<div className={"flex row middle-xs"}>
														<div style={{marginRight: 15}}>
															<img className={"pos_history_image"}
															     src={item.product.product_image_file_upload.url}
															     alt={"ProductB49ERP"}/>
														</div>
														<div style={{flex: 1}}>
															<strong>{item.product.name}</strong>
															<div style={item.summary.discount > 0 ? {
																textDecoration: 'line-through',
																color: '#ccc'
															} : {color: '#02B04E'}}>฿{parseFloat(item.price).format(2)} / {Helper.getRatioUnit(item.product, item.ratio).unit_name}</div>
															{
																item.summary.discount > 0 ?
																	<div className={"flex row"}>
																		<div style={{color: '#02B04E'}}>
																			{parseFloat(discount_amount).format(2)} / {Helper.getRatioUnit(item.product, item.ratio).unit_name}
																		</div>
																		<div className={"ui label red"}>
																			ลด {item.summary.discount_type === '฿' ?
																			item.summary.discount_type
																			: null
																		}
																			{
																				item.summary.discount.format(2)
																			}
																			{
																				item.summary.discount_type === '%' ?
																					item.summary.discount_type
																					: null
																			}
																		</div>
																	</div>
																	: null
															}
															<div>
																{
																	item.payment_item_serial_number
																	&&
																	item.payment_item_serial_number.map((payment_item_serial_number) => {
																		return (
																			<div key={payment_item_serial_number.id}>
																				<i className={'icon barcode'}/>{payment_item_serial_number.product_serial_number.serial_number}
																			</div>
																		)
																	})
																}
															</div>
														</div>
													</div>
												</div>
												<div className={"col-xs-3 padded"}>{item.quantity2}</div>
												<div
													className={"col-xs-3 padded"}>{item.summary.total_net_price.format(2, 3, {pretty: false})}</div>
											</div>
										);
									})
								}
							</div>

						</div>
						<div className={"col-lg-6 padded pos_history_payment column"}>
							<div className={"flex"} style={{flex: 1}}>
								<div className={"flex row middle-xs payment-summary-details-row"}>
									<div><strong>รวมทั้งสิ้น</strong></div>
									<div className={"right floated"}>
										{this.state.payment.summary.total_price_before_discount.format(2, 3, {pretty: false})} บาท
									</div>
								</div>
								<div className={"flex row middle-xs payment-summary-details-row"}>
									<div><strong>ส่วนลดรวม</strong></div>
									<div className={"right floated"}>
										{this.state.payment.summary.discount_amount.format(2, 3, {pretty: false})} บาท
									</div>
								</div>
								<div className={"flex row middle-xs payment-summary-details-row"}>
									<div><strong>รวมมูลค่าสินค้า</strong></div>
									<div className={"right floated"}>
										{(parseFloat(this.state.payment.summary.total_price) - parseFloat(this.state.payment.summary.discount_amount)).format(2, 3, {pretty: false})} บาท
									</div>
								</div>
								<div className={"flex row middle-xs payment-summary-details-row"}>
									<div>
										<strong>ภาษีมูลค่าเพิ่ม {this.state.payment.summary.tax}%</strong>
									</div>
									<div className={"right floated"}>
										{parseFloat(this.state.payment.summary.total_tax_price).format(2, 3, {pretty: false})} บาท
									</div>
								</div>
								<div className={"flex row middle-xs payment-summary-details-row"}>
									<div><strong>ราคาไม่รวมภาษีมูลค่าเพิ่ม</strong></div>
									<div className={"right floated"}>
										{parseFloat(this.state.payment.summary.total_price_exclude_vat).format(2, 3, {pretty: false})} บาท
									</div>
								</div>
								<div className={"flex row middle-xs payment-summary-details-row"}>
									<div><strong>จำนวนเงินรวมทั้งสิ้น</strong></div>
									<div className={"right floated"}>
										{parseFloat(this.state.payment.summary.total_net_price_without_withholding_tax).format(2, 3, {pretty: false})} บาท
									</div>
								</div>
								<div className={"flex row middle-xs payment-summary-details-row"}>
									<div><strong>ยอดชำระ</strong></div>
									<div className={"right floated"}>
										{parseFloat(this.state.payment.summary.total_net_price).format(2, 3, {pretty: false})} บาท
									</div>
								</div>
								{
									this.state.payment.payment.length > 0 ?
										<div className={"ui divider"}/>
										: null
								}
								{
									this.state.payment.payment.map((payment_by, payment_by_key) => {
										if (payment_by.payment_by === 'cash'
											&& payment_by.price > 0
										) {
											return (
												<div key={payment_by_key}>
													<div className={"flex row middle-xs payment-summary-details-row"}>
														<div><strong>เงินสด</strong></div>
														<div className={"right floated"}>
															{payment_by.price.format(2, 3, {pretty: false})} บาท
														</div>
													</div>
													{
														payment_by.payment_by_cash_pos ?
															<>
																<div
																	className={"flex row middle-xs payment-summary-details-row"}>
																	<div><strong>รับเงิน</strong></div>
																	<div className={"right floated"}
																	     style={{color: '#02B04E'}}>
																		{payment_by.payment_by_cash_pos.receive_amount.format(2, 3, {pretty: false})} บาท
																	</div>
																</div>
																<div
																	className={"flex row middle-xs payment-summary-details-row"}>
																	<div><strong>เงินทอน</strong></div>
																	<div className={"right floated"}
																	     style={{color: '#D85356'}}>
																		{payment_by.payment_by_cash_pos.change_amount.format(2, 3, {pretty: false})} บาท
																	</div>
																</div>
															</>
															: null
													}

												</div>
											);
										}
										if (payment_by.payment_by === 'bank_transfer'
											&& parseFloat(payment_by.price) > 0
										) {
											return (
												<div className={"flex row middle-xs payment-summary-details-row"}
												     key={payment_by_key}>
													<div><strong>โอนเงิน</strong></div>
													<div className={"right floated"}>
														{payment_by.price.format(2, 3, {pretty: false})} บาท
													</div>
												</div>
											);
										}
										return null;
									})
								}
								<div className={"ui divider payment-summary-details-row"}/>
							</div>
							<div className="">
								<div className="ui toggle checkbox"
								     style={{
									     margin: '2.5rem 0',
									     fontSize: '1.5rem'
								     }}
								     data-form2_setup="true">
									<input type="checkbox"
									       name="is_auto_print_receipt"
									       tabIndex="0"
									       defaultChecked={
										       localStorage.getItem('is_auto_print_receipt')
											       ? localStorage.getItem('is_auto_print_receipt') === '1'
											       : false
									       }
									       className="hidden"
									/>
									<label>พิมพ์ใบเสร็จอัตโนมัติ</label>
								</div>
								<button className={"ui button green fluid custom-submit-btn"}
								        style={{padding: button_padding, fontSize: button_fontSize, cursor: 'pointer'}}
								        ref={(ref) => {
									        this.$success_payment_button = window.$(ref);
								        }}
								        onClick={() => {
									        this.$payment_history_details.remove();
								        }}
								>
									ปิด
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export class POSHistory extends React.Component {
	constructor() {
		super();
		this.state = {
			payment: [],
			category: [
				{title: 'ล่าสุด', active: true},
				// {title: 'เมื่อวาน',active : false},
			],
			qs: window.Global.getAllQueryStrings(),
			isLoadingNext: true,
			is_loading: true,
			limit: 5,
			page: 1,
			pos: localStorage.getItem("pos") ? JSON.parse(localStorage.getItem("pos")) : false,
		}
	}

	componentDidMount() {

		window.$('.slide-menu-root').css({display: 'none'});
		window.$('.Wrapper_root').css({padding: 0});
		document.addEventListener('contextmenu', event => event.preventDefault());
		this.fetchHistory();
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.location.search !== prevProps.location.search) {
			this.setState({
				payment: [],
				category: [
					{title: 'ล่าสุด', active: true},
					// {title: 'เมื่อวาน',active : false},
				],
				isLoadingNext: true,
				is_loading: true,
				qs: window.Global.getAllQueryStrings()
			}, () => {
				this.fetchHistory();
			})
		}
	}

	fetchHistory() {
		if (!this.state.pos) {
			this.props.history.push("/v2/sale_orders/pos");
			return false;
		}
		let data = window.Global.getAllQueryStrings();
		data.from_device = 'mobile';
		window.Global.ajax({
			url: process.env.REACT_APP_DOMAIN + '/api/payment',
			method: "GET",
			data: {
				...data,
				payment_pos_pos_id: this.state.pos.id,
				show_deleted: 1,
				status: 'all',
				page: this.state.page,
				limit: this.state.limit,
			},
			done: (responseJson) => {
				// console.log(responseJson);
				let isLoadingNext = true;
				if (responseJson.payment.length < this.state.limit) {
					isLoadingNext = false;
				}
				this.setState({
					count: responseJson.count,
					payment: this.state.payment.concat(responseJson.payment),
					isLoadingNext: isLoadingNext,
					is_loading: false,
				})
			}
		})
	}

	paymentCancel(payment, payment_key) {
		window.Global.ajax({
			url: process.env.REACT_APP_DOMAIN + '/api/sale_order/payment',
			method: 'DELETE',
			data: {
				payment_id: payment.id,
				is_void_sale_order: true,
			},
			done: (responseJson) => {
				Helper.messageTopPOS({
					type: 'positive',
					message: 'ยกเลิกเรียบร้อย'
				});
				let _payment = [...this.state.payment];
				_payment[payment_key] = responseJson.payment;
				this.setState({
					count: responseJson.count,
					payment: _payment,
				});
			}
		})
	}


	render() {
		return (
			<div ref={(ref) => {
				if (!ref) return;
				this.$parent = window.$(ref);
			}}
			     style={{background: 'white', height: '100%', padding: '1rem'}}
			     key={'ddd' + window.Global.getRandomInt(1, 99999999)}
			     className="main ui container"
			>
				<div id="HeaderTop_root"
				     style={{backgroundColor: 'white', padding: '1rem'}}
				     className="flex row wrap center-xs"
				>
					<div>
						<Link to={"/v2/sale_orders/pos"} className={"ui button basic massive"}
						      style={{padding: button_padding, fontSize: button_fontSize}}
						>
							กลับ
						</Link>
						<Link to={"/v2/sale_orders/pos/history"} className={"ui button basic massive"}
						      style={{padding: button_padding, fontSize: button_fontSize}}
						>
							ประวัติ
						</Link>
					</div>
				</div>
				<div className="flex"
				     id={"History_root"}
				>
					<div className={"history-category"}>
						{
							this.state.category.map((cate, cate_index) => {
								return (
									<div
										key={cate_index}
										onClick={() => {
											let category = [...this.state.category];
											this.state.category.map((cat, cat_i) => {
												category[cat_i].active = false;
												return true;
											});
											category[cate_index].active = true;
											this.setState({
												category: category,
											})
										}}
									>
										<button className={"active"}>
											{cate.title}
										</button>
									</div>
								);
							})
						}
					</div>
					<div>
						{
							this.state.is_loading
								? <div className="tr">
									<div className="td center aligned" data-info="nodata">
										<div className="ui active centered inline huge loader"/>
									</div>
								</div>
								: null
						}
						{
							!this.state.is_loading
							&& this.state.payment.length === 0
							&& (
								!window.Global.getAllQueryStrings().page
								|| window.Global.getAllQueryStrings().page === '1'
							) ?
								<div className="tr">
									<div className="td span16"
									     style={{textAlign: 'center', fontSize: '2rem'}}>ไม่พบข้อมูล
									</div>
								</div>
								: null
						}
						{
							!this.state.is_loading
							&& this.state.payment.length > 0 ?
								this.state.payment.map((payment, payment_i) => {
									return (
										<div key={payment_i}
										     className={"tr"}
										>
											<div className={
												"history_box "
												+ (
													payment.is_deleted
														? ' bg-red-200 '
														: ' bg-gray-100 '
												)
											}>
												<i className={"icon tag"}/>
												<div className={"history_details"}>
													<div
														onClick={() => {
															window.Global.reactToDom(
																window.$('#History_root'),
																<PaymentModalDetails
																	payment={payment}
																	onSaleOrderCancle={(_payment, options) => {
																		onSaleOrderCancle(_payment, options)
																	}}
																/>
															)
														}}
													>
														<div className={"history_desc"}>{payment.desc}</div>
														<div
															className={"history_name"}>{payment.relationship.name}</div>
														<div
															className={"history_description"}>{payment.payment_item.length} รายการ
															• {window.Global.getDateThai(payment.doc_date)}
														</div>
													</div>
													<div className={"flex row"} style={{marginTop: '1rem'}}>
														<div className={"history_print"}
														     onClick={() => {
															     if (payment.is_printing) {
																     return false;
															     }
															     let _payment = [...this.state.payment];
															     _payment[payment_i].is_printing = true;
															     this.setState({
																     payment: _payment,
															     }, () => {
																     _payment[payment_i].is_printing = false;
																     Helper.printerQueue(payment, {
																	     onSuccess: () => {
																		     Helper.messageTopPOS({
																			     type: 'positive',
																			     message: 'กำลังพิมพ์เอกสาร'
																		     });
																		     this.setState({
																			     payment: _payment
																		     });
																	     },
																	     onError: (responseJson) => {
																		     Helper.messageTopPOS({
																			     type: 'negative',
																			     message: responseJson.message[0].error_message,
																			     delay: 5000
																		     })
																		     this.setState({
																			     payment: _payment
																		     });
																	     }
																     })
															     });

														     }}
														>
															{
																payment.is_printing ?
																	"กำลังพิมพ์ใบเสร็จ" : "พิมพ์ใบเสร็จ"
															}
														</div>
														{
															payment.is_deleted ?
																<div className={"history_cancle opacity-40"}></div>
																:
																<div className={"history_cancle"}
																     onClick={() => {
																	     onSaleOrderCancle(payment, {
																		     onDone: (response) => {
																			     Helper.messageTopPOS({
																				     type: 'positive',
																				     message: 'ยกเลิกเรียบร้อย'
																			     });
																			     let _payment = [...this.state.payment];
																			     _payment[payment_i] = response.payment;
																			     this.setState({
																				     count: response.count,
																				     payment: _payment,
																			     });
																		     }
																	     });
																     }}
																>ยกเลิก</div>
														}
													</div>

												</div>
												<div
													className={"history_price"}>{payment.summary.total_net_price.format(2, 3, {pretty: false})} บาท
												</div>
											</div>

										</div>
									)
								}) : null
						}
					</div>

					{
						!this.state.is_loading
						&& this.state.isLoadingNext ?
							<button className={"ui button massive fluid"}
							        style={{
								        padding: button_padding,
								        fontSize: button_fontSize,
								        marginTop: '1rem',
								        marginBottom: '1rem'
							        }}
							        ref={(ref) => {
								        this.loading_next = window.$(ref);
							        }}
							        onClick={() => {
								        if (this.loading_next.hasClass('loading')) {
									        return false;
								        }
								        this.loading_next.addClass('loading');
								        this.setState({
									        page: this.state.page + 1,
								        }, () => {
									        this.fetchHistory();
								        })
							        }}
							>
								ดูเพิ่ม
							</button>
							: null
					}
				</div>
			</div>
		);
	}
}

class POSCategoryModal extends React.Component {
	render() {
		return (
			<div className={"custom-modal center-xs"}
			     ref={(ref) => {
				     this.$modal = window.$(ref);
				     this.$modal.find('form').form2('setup')
				     this.$modal.find('form').form2('submit', {
					     url: process.env.REACT_APP_DOMAIN + '/api/filter',
					     method: this.props.mode === 'create' ? 'POST' : 'PUT',
					     loadingButton: this.$modal.find('.button.approve'),
					     beforeSent: (data) => {
						     if (this.props.mode === 'edit') {
							     data.filter_id = this.props.filter.id;
						     }
						     return data;
					     },
					     onSuccess: (response) => {
						     Helper.messageTopPOS({
							     type: 'positive',
							     message: this.props.mode === 'create' ? 'เพิ่มหมวดหมู่สำเร็จ' : "บันทึกหมวดหมู่สำเร็จ"
						     });
						     this.props.onSuccess(response.filter);
						     this.$modal.remove();
					     }
				     })
			     }}
			>
				<div className={"overlay"}
				     onClick={() => {
					     this.$modal.remove()
				     }}
				/>
				<div className="ui segment" style={{width: '60%'}}>
					<div className={"header"}>
						<h1 className={"ui header"} style={{marginBottom: '1rem'}}>
							{this.props.mode === 'create' ? 'เพิ่ม' : null}
							{this.props.mode === 'edit' ? 'แก้ไข' : null}
							หมวดหมู่
						</h1>
					</div>
					<div className={"content"}>
						<form className={"ui form manage-item-custom"}>
							<div className={"field"}>
								<input ref={(ref) => this.$filter_name = window.$(ref)}
								       name={"name"}
								       placeholder={"กรอกชื่อหมวดหมู่"}
								       defaultValue={this.props.filter ? this.props.filter.name : null}
								/>
								<input type={"hidden"}
								       name={"type"}
								       defaultValue={"product_category_for_pos"}
								/>
							</div>
							<div className="ui error message"/>
							<div className={"flex row actions"} style={{marginTop: '2rem'}}>
								{
									this.props.mode === 'edit' ?
										<button className={"ui button deny basic"}

										        style={{
											        padding: button_padding,
											        fontSize: button_fontSize,
											        cursor: 'pointer',
											        marginLeft: 0
										        }}
										        type={"button"}
										        onClick={() => {
											        Helper.posConfirmModal({
												        title: 'ลบหมวดหมู่',
												        content: "โปรดยืนยันการลบหมวดหมู่ การกระทำนี้ไม่สามารถกู้ข้อมูลคืนได้",
												        cancel_text: 'ไม่ดำเนินการ',
												        approve_text: 'ลบหมวดหมู่',
												        onApprove: () => {
													        let data = {filter_id: this.props.filter.id}
													        window.Global.ajax({
														        method: 'DELETE',
														        url: process.env.REACT_APP_DOMAIN + '/api/filter',
														        data: data,
														        done: () => {
															        this.$modal.remove()
															        this.props.onDeleteSuccess();
															        Helper.messageTopPOS({
																        type: 'positive',
																        message: 'ลบหมวดหมู่เรียบร้อย'
															        });
														        }
													        })
												        }
											        });
										        }}
										>ลบ</button>
										: null
								}
								<div className={"right floated"}>
									<button className={"ui button basic"}
									        onClick={() => {
										        this.$modal.remove();
									        }}
									        style={{
										        padding: button_padding,
										        fontSize: button_fontSize,
										        cursor: 'pointer'
									        }}
									        type={"button"}
									>ปิด
									</button>
									<button className={"ui button approve green"}
									        style={{
										        padding: button_padding,
										        fontSize: button_fontSize,
										        cursor: 'pointer',
										        marginRight: 0,
									        }}
									        type={"submit"}

									>
										{this.props.mode === 'create' ? 'เพิ่มหมวดหมู่' : null}
										{this.props.mode === 'edit' ? 'บันทึก' : null}
									</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		);
	}
}

class POSProductCategoryModal extends React.Component {
	constructor() {
		super();
		this.state = {
			filter: [],
			search_query: '',
			is_loading: true,
		}
	}

	componentDidMount() {
		this.fetch();
	}

	fetch() {
		let data = {}
		data.search_query = this.state.search_query;
		data.type = 'product_category_for_pos';
		data.all = true;
		data.request_data_filter_product_category_for_pos = {
			product_id: this.props.product.id,
			pos_id: this.props.pos.id,
		};
		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/filter',
			data: data,
			done: (responseJson) => {
				let filter = [...responseJson.filter];
				let storage_filter = window.localStorage.getItem("filter_priority") && window.localStorage.getItem("filter_priority") !== "" ? JSON.parse(window.localStorage.getItem("filter_priority")) : [];
				if (storage_filter.length > 0) {
					responseJson.filter.map((item, item_i) => {
						storage_filter.map((_storage_filter, _storage_filter_i) => {
							if (item.id === _storage_filter.id) {
								filter[item_i].priority = _storage_filter.priority;
							}
							return false;
						})
						return false;
					})
					filter.map((_filter, _filter_i) => {
						if (!_filter.priority) {
							filter[_filter_i].priority = 0;
						}
						return false;
					})
					filter.sort((a, b) => {
						return a.priority - b.priority
					})
				}
				this.setState({
					filter: filter,
					is_loading: false,
				})
			}
		})
	}

	render() {
		return (
			<div className={"custom-modal center-xs"}
			     ref={(ref) => {
				     this.$filter_priority = window.$(ref)
			     }}
			>
				<div className={"overlay"}
				     onClick={() => {
					     this.$filter_priority.remove();
					     this.props.fetchProduct();
				     }}
				/>
				<div className="ui segment" style={{width: '60%'}}>
					<div className={"header"} style={{marginBottom: '1.8rem'}}>
						<h1 className={"ui header"}>
							เลือกหมวดหมู่
							{
								this.props.product ?
									<div className={"sub header"} style={{marginTop: 5}}>
										{this.props.product.name}
									</div>
									: null
							}
						</h1>
					</div>
					<div className={"content"}>
						<form className={"ui form massive manage-item-custom"}>
							<input type="text"
							       name={"search_query"}
							       placeholder="ค้นหาชื่อหมวดหมู่สินค้า"
							       defaultValue={""}
							       style={{flex: 1}}
							       onChange={(e) => {
								       let search_query = e.target.value;
								       this.setState({
									       is_loading: true,
									       search_query: search_query,
								       }, () => {
									       this.fetch();
								       })
							       }}
							/>
						</form>
						{
							this.state.is_loading ?
								<div className="ui active centered inline loader" style={{marginTop: 15}}/>
								: null
						}
						{
							!this.state.is_loading
							&& this.state.filter.length > 0 ?
								<div className={"ui list"} style={{flex: 1, overflowY: 'auto', maxHeight: 680}}>
									{
										this.state.filter.map((filter, filter_i) => {

											return (
												<div className="item"
												     key={filter_i}
												>
													<button className={"ui button basic fluid flex row middle-xs"}
													        style={{
														        textAlign: 'left',
														        padding: button_padding,
														        fontSize: '2.5rem',
														        cursor: 'pointer',
														        color: '#00000'
													        }}
													        onClick={(e) => {
														        let _this = window.$(e.target);
														        if (_this.hasClass('loading')) {
															        return;
														        }
														        _this.addClass('loading');
														        let data = {};
														        if (!filter.filter_product_category_for_pos) {
															        data.filter_id = filter.id;
															        data.product_id = this.props.product.id;
															        data.pos_id = this.props.pos.id;
															        window.Global.ajax({
																        method: 'POST',
																        url: process.env.REACT_APP_DOMAIN + '/api/v1/filter_product_category_for_pos',
																        data: data,
																        done: async (responseJson) => {
																	        if (responseJson.success) {
																		        let __filter = [...this.state.filter];
																		        __filter[filter_i] = responseJson.filter
																		        await this.setState({
																			        filter: __filter,
																		        })
																	        }
																	        _this.removeClass('loading');
																        }
															        })
														        }

														        if (filter.filter_product_category_for_pos) {
															        data.filter_id = filter.id;
															        data.filter_product_category_for_pos_id = filter.filter_product_category_for_pos.id;
															        window.Global.ajax({
																        method: 'DELETE',
																        url: process.env.REACT_APP_DOMAIN + '/api/v1/filter_product_category_for_pos',
																        data: data,
																        done: async (responseJson) => {
																	        if (responseJson.success) {
																		        let __filter = [...this.state.filter];
																		        __filter[filter_i] = responseJson.filter
																		        await this.setState({
																			        filter: __filter,
																		        })
																	        }
																	        _this.removeClass('loading');
																        }
															        })
														        }
													        }}
													>
														{filter.name}
														<span className={"right floated"} id={"icon"}>
										   {
											   filter.filter_product_category_for_pos ?
												   <i className="check icon"
												      style={{color: 'green'}}/>
												   : null
										   }
										   </span>
													</button>
												</div>
											);
										})
									}
								</div>
								: null
						}
						{
							!this.state.is_loading
							&& (this.state.filter.length === 0) ?
								<div className={"search-empty"} style={{textAlign: 'center'}}>ไม่มีประเภท</div>
								: null
						}
					</div>
				</div>
			</div>
		);
	}
}

class POSCategoryPriorityModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			filter: [...props.filter],
			search_query: '',
			is_loading: false,
		}
	}

	componentDidMount() {
		this.fetch();
	}

	fetch() {
		let data = {
			type: 'product_category_for_pos',
			all: true
		}
		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/filter',
			data: data,
			done: (responseJson) => {
				let filter = [...responseJson.filter];
				let storage_filter = window.localStorage.getItem("filter_priority") && window.localStorage.getItem("filter_priority") !== "" ? JSON.parse(window.localStorage.getItem("filter_priority")) : [];
				if (storage_filter.length > 0) {
					responseJson.filter.map((item, item_i) => {
						storage_filter.map((_storage_filter, _storage_filter_i) => {
							if (item.id === _storage_filter.id) {
								filter[item_i].priority = _storage_filter.priority;
							}
							return false;
						})
						return false;
					})
					filter.map((_filter, _filter_i) => {
						if (!_filter.priority) {
							filter[_filter_i].priority = 0;
						}
						return false;
					})
					filter.sort((a, b) => {
						return a.priority - b.priority
					})
				}
				this.setState({
					filter: filter
				})
			}
		})
	}


	onSortEnd = ({oldIndex, newIndex}) => {
		let filters = [...this.state.filter];
		filters.splice(oldIndex, 1)
		let new_filter = [];
		let old_obj = this.state.filter[oldIndex];
		filters.map((_filter, _filter_i) => {
			if (_filter_i === newIndex && newIndex === 0) {
				new_filter.push(old_obj)
			}
			new_filter.push(_filter);
			if (_filter_i === (newIndex - 1) ||
				(newIndex === filters.length && (_filter_i + 1) === filters.length)
			) {
				new_filter.push(old_obj)
			}
			return false;
		})
		let storage_filter = [];
		new_filter.map((filter, filter_i) => {
			let priority = (filter_i + 1);
			new_filter[filter_i].priority = priority;
			storage_filter.push({id: filter.id, priority: priority});
			return false;
		});
		this.setState({
			filter: new_filter,
		}, () => {
			window.localStorage.setItem('filter_priority', JSON.stringify(storage_filter));
			this.props.onSuccessSwap(this.state.filter);
		})

	};

	render() {

		return (
			<div className={"custom-modal center-xs"}
			     ref={(ref) => {
				     this.$filter_priority = window.$(ref)
			     }}
			>
				<div className={"overlay"}
				     onClick={() => {
					     this.props.fetchFilter();
					     this.$filter_priority.remove();
				     }}
				/>
				<div className="ui segment" style={{width: '60%'}}>
					<div className={"header"}>
						<div className={"flex row middle-xs"}>
							<h1 className={"ui header"} style={{marginBottom: 0}}>
								เรียงลำดับหมวดหมู่
							</h1>
							<div className="right floated">
								<button
									className={"ui button massive"}
									onClick={() => {
										window.Global.reactToDom(window.$('body'),
											<POSCategoryModal
												mode={"create"}
												pos={this.props.pos}
												onSuccess={(filter) => {
													this.fetch();
												}}
											/>
										)
									}}
								>
									เพิ่มหมวดหมู่
								</button>
							</div>
						</div>
					</div>
					<div className={"content"}>
						{
							this.state.is_loading ?
								<div className="ui active centered inline loader" style={{marginTop: 15}}/>
								: null
						}
						{
							!this.state.is_loading
							&& this.props.filter.length > 0 ?
								<SortableContainer onSortEnd={this.onSortEnd} useDragHandle>
									<div className={"ui list"} style={{maxHeight: 795, overflowY: 'auto'}}>
										{
											this.state.filter.map((filter, filter_i) => {

												return (
													<SortableItem
														key={`item-${filter_i}`}
														index={filter_i}
													>
														<div className="item" style={{zIndex: 1000}}>
															<div
																className={"ui button basic fluid middle-xs"}
																id={"custom-button-dragdrop"}
																style={{
																	textAlign: 'left',
																	fontSize: button_fontSize,
																	cursor: 'pointer'
																}}
															>
																<div className={"flex row middle-xs"}>
																	<DragHandle key={`item-${filter_i}`}>
																		<div style={{
																			fontSize: '2.5rem',
																			color: '#000',
																			lineHeight: 1,
																		}}>
																			<i className={"icon bars"}
																			   style={{marginRight: '1rem'}}
																			/>
																			{filter.name}
																		</div>
																	</DragHandle>
																	<div className={"right floated"}>
																		<button className={"ui button"}
																		        onClick={() => {
																			        window.Global.reactToDom(
																				        window.$('body'),
																				        <POSCategoryModal
																					        mode={"edit"}
																					        pos={this.props.pos}
																					        filter={filter}
																					        onSuccess={(response_filter) => {
																						        let _filter = [...this.props.filter];
																						        _filter[filter_i] = response_filter;
																						        this.setState({
																							        filter: _filter,
																						        }, () => {
																							        this.fetch();
																						        })
																					        }}
																					        fetchFilter={() => {
																						        this.props.fetchFilter();
																					        }}
																					        onDeleteSuccess={() => {
																						        this.fetch();
																					        }}
																				        />
																			        );
																		        }}
																		        style={{
																			        fontSize: '2rem',
																			        marginRight: 0
																		        }}
																		>
																			แก้ไข
																		</button>
																	</div>
																</div>
															</div>
														</div>
													</SortableItem>
												);
											})
										}
									</div>
								</SortableContainer>
								: null
						}
						{
							!this.state.is_loading
							&& (this.props.filter.length === 0) ?
								<div className={"search-empty"} style={{textAlign: 'center'}}>ไม่มีประเภท</div>
								: null
						}
					</div>
				</div>
			</div>
		);
	}
}

function onSaleOrderCancle(payment, options) {
	Helper.posConfirmModal({
		title: 'ยกเลิก',
		content: "โปรดยืนยันยกเลิก การกระทำนี้ไม่สามารถกู้ข้อมูลคืนได้",
		cancel_text: 'ไม่ดำเนินการ',
		approve_text: 'ยกเลิกเอกสาร',
		onApprove: () => {
			let data = {
				payment_id: payment.id,
				is_void_sale_order: true,
			};
			window.Global.ajax({
				method: 'DELETE',
				url: process.env.REACT_APP_DOMAIN + '/api/sale_order/payment',
				data: data,
				done: (response) => {
					if (options.onDone) {
						options.onDone(response);
					}
				}
			})
		}
	})
}

export class POSDialyReport extends React.Component {
	constructor() {
		super();
		this.state = {
			payment: [],
			category: [
				{title: 'ล่าสุด', active: true},
				// {title: 'เมื่อวาน',active : false},
			],
			qs: window.Global.getAllQueryStrings(),
			isLoadingNext: true,
			is_loading: true,
			limit: 5,
			page: 1,
			pos: localStorage.getItem("pos") ? JSON.parse(localStorage.getItem("pos")) : false,
		}
	}

	componentDidMount() {

		window.$('.slide-menu-root').css({display: 'none'});
		window.$('.Wrapper_root').css({padding: 0});
		document.addEventListener('contextmenu', event => event.preventDefault());
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.location.search !== prevProps.location.search) {
			this.setState({
				payment: [],
				category: [
					{title: 'ล่าสุด', active: true},
					// {title: 'เมื่อวาน',active : false},
				],
				isLoadingNext: true,
				is_loading: true,
				qs: window.Global.getAllQueryStrings()
			})
		}
	}

	render() {
		return <DailyReport location={this.props.location} button_padding={button_padding}
		                    button_fontSize={button_fontSize}/>
	}
}

class SplitBillPayment extends React.Component {
	constructor(props) {
		super(props);
		let split_payment = cloneDeep(props.default_payment);
		split_payment.item = [];
		let current_payment = cloneDeep(props.default_payment);
		props.default_payment.item.map((item, item_i) => {
			// let calculate_item_price = Helper.CalculateItemPrice(item, {
			// 	tax_type: props.default_payment.tax_type,
			// })
			// if (item.discount !== 0 && item.discount_type === '฿') {
			// 	current_payment.item[item_i].price = (parseFloat(calculate_item_price.total_net_price / item._quantity)).round(2);
			// 	current_payment.item[item_i].discount = 0;
			// }
			current_payment.item[item_i].max_quantity = item._quantity;
			return true;
		})
		this.state = {
			default_payment: cloneDeep(current_payment),
			current_payment: cloneDeep(current_payment),
			split_bill_payment: split_payment,
			pos: props.pos || {},
		}
		this.SplitPayment = React.createRef();
		this.CurrentPayment = React.createRef();
	}

	render() {
		return (
			<div className={"custom-modal with-bg"}
			     ref={(ref) => {
				     this.$modal = window.$(ref)
			     }}
			     id={"split_payment"}
			>
				<div className="ui segment flex"
				     style={{width: '100%', height: '100%'}}
				>
					<div className={"flex"} style={{flex: 1, height: '100%'}}>
						<div className="content ui form manage-item-custom custom-split-content"
						     style={{fontSize: allpage_fontSize, height: '100%'}}>
							<div className="flex row padded" style={{height: '100%'}}>
								<div className="col-xs-8 column padded"
								     id={"current_segment"}
								     style={{height: '100%'}}
								>
									<div className="ui padded segments stciky-segment"
									     id={"payment_active_item"}
									     style={{
										     display: "flex",
										     flexDirection: 'column',
										     height: '100%'
										     // height: window.$('.main-section').height(),
									     }}
									>
										<div className="ui segment" id={"payment-action"}>
											<h2 className={"ui header"}>รายการคงเหลือ</h2>
										</div>
										<Payment
											ref={this.CurrentPayment}
											key={"current_payment"}
											payment={this.state.current_payment}
											pos={this.state.pos || {}}
											split_mode={true}
											current_bill_payment={true}
											updatePaymentItem={(item) => {
												if (item._quantity >= 0) {
													let _item = cloneDeep(item);
													_item._quantity = 1;
													this.SplitPayment.current.increaseItem(_item);
												}
											}}
											onUpdateRelationship={(payment) => {
												this.setState({
													current_payment: cloneDeep(payment),
												}, () => {
													this.CurrentPayment.current.setPayment(this.state.current_payment);
												})
											}}
											// updatePayment={(payment) => {
											// 	let split_items = [];
											// 	this.state.default_payment.item.map((default_item, default_item_i) => {
											// 		payment.item.map((item, item_i) => {
											// 			if (item.product.id === default_item.product.id
											// 				&& item.discount === default_item.discount
											// 				&& item.discount_type === default_item.discount_type
											// 				&& item.ratio === default_item.ratio
											// 				&& item.price === default_item.price
											// 				&& item._quantity !== default_item._quantity
											// 			) {
											// 				let split_item = {...item};
											// 				split_item._quantity = parseFloat(default_item._quantity) - parseFloat(item._quantity);
											// 				split_item.quantity = parseFloat(split_item._quantity) * parseFloat(split_item.ratio);
											// 				split_item.product_serial_number = this.state.default_payment.item[default_item_i].product_serial_number.filter((product_serial_number, product_serial_number_i) => {
											// 					return product_serial_number_i < parseFloat(split_item._quantity)
											// 				})
											// 				split_item._product_serial_number = this.state.default_payment.item[default_item_i]._product_serial_number.filter((product_serial_number, product_serial_number_i) => {
											// 					return product_serial_number_i < parseFloat(split_item._quantity)
											// 				})
											// 				split_item.max_quantity = parseFloat(default_item._quantity);
											// 				split_items.push(split_item)
											//
											//
											// 				payment.item[item_i].product_serial_number = this.state.default_payment.item[default_item_i].product_serial_number.filter((product_serial_number, product_serial_number_i) => {
											// 					return product_serial_number_i >= parseFloat(split_item._quantity)
											// 				})
											// 				payment.item[item_i]._product_serial_number = this.state.default_payment.item[default_item_i]._product_serial_number.filter((product_serial_number, product_serial_number_i) => {
											// 					return product_serial_number_i >= parseFloat(split_item._quantity)
											// 				})
											//
											// 			}
											// 			return false;
											// 		})
											// 		return false;
											// 	})
											// 	let split_bill_payment = {...this.state.split_bill_payment};
											// 	split_bill_payment.item = split_items;
											// 	this.setState({
											// 		current_payment: payment,
											// 		split_bill_payment: split_bill_payment
											// 	})
											// }}
										/>
									</div>
								</div>
								<div className="col-xs-8 column padded" style={{height: '100%'}}
									// id={"split_segment"}
									  id={"current_segment"}
								>
									<div className="ui padded segments stciky-segment"
									     style={{
										     display: "flex",
										     flexDirection: 'column',
										     height: '100%'
										     // height: window.$('.main-section').height(),
									     }}
									>
										<div className="ui segment flex row middle-xs">
											<h2 className={"ui header"} style={{marginBottom: 0}}>รายการแยกจ่าย</h2>
										</div>
										<Payment
											ref={this.SplitPayment}
											key={"split_payment"}
											payment={this.state.split_bill_payment}
											pos={this.state.pos || {}}
											split_mode={true}
											split_bill_payment={true}
											onUpdateRelationship={(payment) => {
												this.setState({
													split_bill_payment: cloneDeep(payment),
												}, () => {
													this.SplitPayment.current.setPayment(this.state.split_bill_payment);
												})
											}}
											inCreaseItem={(item) => {
												let _item = cloneDeep(item);
												_item._quantity = 1;
												this.CurrentPayment.current.decreaseItem(_item);
											}}
											deCreaseItem={(item) => {
												if (item._quantity >= 0) {
													let _item = cloneDeep(item);
													_item._quantity = 1;
													this.CurrentPayment.current.increaseItem(_item);
												}
											}}
											// updatePayment={(payment) => {
											// 	let current_payment = {...this.state.current_payment};
											// 	this.state.default_payment.item.map((default_item, default_item_i) => {
											// 		payment.item.map((item, item_i) => {
											// 			if (item.product.id === default_item.product.id
											// 				&& item.discount === default_item.discount
											// 				&& item.discount_type === default_item.discount_type
											// 				&& item.ratio === default_item.ratio
											// 				&& item.price === default_item.price
											// 				// && item._quantity !== default_item._quantity
											// 			) {
											// 				current_payment.item[default_item_i]._quantity = parseFloat(default_item._quantity) - parseFloat(item._quantity);
											// 				current_payment.item[default_item_i].quantity = parseFloat(current_payment.item[default_item_i]._quantity) * parseFloat(current_payment.item[default_item_i].ratio);
											// 				current_payment.item[default_item_i].product_serial_number = this.state.default_payment.item[default_item_i].product_serial_number.filter((product_serial_number, product_serial_number_i) => {
											// 					return product_serial_number_i >= parseFloat(item._quantity)
											// 				})
											// 				current_payment.item[default_item_i]._product_serial_number = this.state.default_payment.item[default_item_i]._product_serial_number.filter((product_serial_number, product_serial_number_i) => {
											// 					return product_serial_number_i >= parseFloat(item._quantity)
											// 				})
											// 				payment.item[item_i].product_serial_number = this.state.default_payment.item[default_item_i].product_serial_number.filter((product_serial_number, product_serial_number_i) => {
											// 					return product_serial_number_i < parseFloat(item._quantity)
											// 				})
											// 				payment.item[item_i]._product_serial_number = this.state.default_payment.item[default_item_i]._product_serial_number.filter((product_serial_number, product_serial_number_i) => {
											// 					return product_serial_number_i < parseFloat(item._quantity)
											// 				})
											// 			}
											// 			return false;
											// 		})
											// 		return false;
											// 	})
											// 	payment.item = payment.item.filter((item) => {
											// 		return parseFloat(item._quantity) > 0
											// 	})
											// 	this.setState({
											// 		current_payment: cloneDeep(current_payment),
											// 		split_bill_payment: cloneDeep(payment)
											// 	})
											// }}
											onClose={() => {
												let payment = {...this.state.default_payment};
												payment.item = payment.item.filter((item) => {
													return parseFloat(item._quantity) > 0
												})
												this.props.onUpdatePayment(payment)
												this.$modal.remove();
											}}
											onSuccessPayment={(responseJson) => {
												let payment = cloneDeep({...this.state.current_payment});
												let current_payment = cloneDeep({...this.state.current_payment});
												payment.item.map((item, item_i) => {
													current_payment.item[item_i].max_quantity = item._quantity;
													return false;
												})
												current_payment.item = current_payment.item.filter((_item) => {
													return _item._quantity > 0
												})
												let split_bill_payment = {...this.state.current_payment};
												split_bill_payment.item = [];
												payment.item = payment.item.filter((item) => {
													return parseFloat(item._quantity) > 0
												})

												this.setState({
													default_payment: cloneDeep(current_payment),
													current_payment: cloneDeep(current_payment),
													split_bill_payment: cloneDeep(split_bill_payment)
												}, () => {
													this.props.onSuccessPayment(responseJson, this.state.default_payment);
													this.CurrentPayment.current.setPayment(this.state.current_payment);
													this.SplitPayment.current.setPayment(this.state.split_bill_payment);
													if (this.state.default_payment.item.length === 0) {
														this.props.onUpdatePayment(this.state.default_payment);
														this.$modal.remove();
													}
												})
											}}
										/>
									</div>
								</div>
							</div>

						</div>
					</div>


				</div>
			</div>
		);
	}
}
